import {
  CertificationStatusDto,
  ExamDayStatusDto,
  ExamStageStatusDto,
  IndividualExamStatusDto,
  NewsCategoryDto,
  NewsStatusDto,
  PracticalExamAttemptStatusDto,
  ResourceTypeDto,
  SurveyAssignmentStatusDto,
} from '@/api/generated';

export type AdminPanelTranslation = {
  certifications: {
    adminInstructions: {
      closeButton: string;
      drawerTitle: string;
      sectionTitles: {
        adminSteps: string;
        employeeView: string;
        purpose: string;
        rules: string;
        transition: string;
      };
      stages: {
        exam: StageInstructionBody;
        plan: StageInstructionBody;
        survey: StageInstructionBody;
        test: StageInstructionBody;
      };
      stepPrefix: string;
    };
    assignSurveyDialog: {
      assignError: string;
      assignExistingTab: string;
      assignSuccess: string;
      chooseFileButton: string;
      clearDeadline: string;
      closeButton: string;
      createAssignButton: string;
      createError: string;
      createNewTab: string;
      creatingButton: string;
      currentlyAssigned: string;
      deadlineHelp: string;
      deadlineLabel: string;
      deadlinePastWarning: string;
      deadlineValidation: string;
      detachButton: string;
      detachError: string;
      detachSuccess: string;
      dragDropText: string;
      fileLabel: string;
      fileRequired: string;
      nameMaxLength: string;
      nameRequired: string;
      noSurveysFound: string;
      orSelectDifferent: string;
      searchButton: string;
      searchPlaceholder: string;
      surveyNameLabel: string;
      title: string;
      validationErrorsTitle: string;
      validationErrorsToast: string;
    };
    deleteDialog: {
      cancelButton: string;
      deleteButton: string;
      deleteError: string;
      deleteSuccess: string;
      deletingButton: string;
      messageEnd: string;
      messageStart: string;
      title: string;
    };
    detail: {
      backButton: string;
      detachError: string;
      detachSuccess: string;
      editButton: string;
      flowTitle: string;
      label: string;
      loading: string;
      metaCreated: string;
      metaDeadline: string;
      metaUpdated: string;
      notFound: string;
      participants: {
        addedAt: string;
        attempts_few: string;
        attempts_many: string;
        attempts_one: string;
        attempts_other: string;
        bestScore: string;
        drill: {
          comments: string;
          commission: string;
          commissionRole: {
            CHAIRMAN: string;
            HRBP: string;
          };
          completedAt: string;
          daysTitle: string;
          noDays: string;
          noTerms: string;
          notPassed: string;
          passed: string;
          questions: string;
          score: string;
          termsTitle: string;
        };
        email: string;
        error: string;
        filters: {
          clear: string;
          csvHint: string;
          employeeSection: string;
          passed: string;
          positionCodes: string;
          regionCodes: string;
          scoreMax: string;
          scoreMin: string;
          status: string;
          surveyAssigned: string;
          title: string;
          tri: {
            any: string;
            no: string;
            yes: string;
          };
        };
        filterStagesPlaceholder: string;
        loading: string;
        name: string;
        noData: string;
        noScore: string;
        openButton: string;
        rowsPerPage: string;
        searchPlaceholder: string;
        stages: string;
        status: {
          ABSENT: string;
          CANCELLED: string;
          COMPLETED: string;
          FAILED: string;
          IN_PROGRESS: string;
          NOT_STARTED: string;
        };
        surveyNotAssigned: string;
        surveyStatus: {
          COMPLETED: string;
          IN_PROGRESS: string;
          NOT_STARTED: string;
        };
        table: {
          exam: string;
          name: string;
          position: string;
          region: string;
          survey: string;
          test: string;
        };
        teaserSubtitle: string;
        title: string;
        titleTooltip: string;
      };
      stageStatusChange: {
        activateButton: string;
        activateSuccess: string;
        cancelButton: string;
        cancelSuccess: string;
        completeButton: string;
        completeSuccess: string;
        error: string;
        label: string;
        revertButton: string;
        revertSuccess: string;
        testClosureConfirm: {
          cancelAction: string;
          confirmAction: string;
          confirmCancel: string;
          confirmComplete: string;
          titleCancel: string;
          titleComplete: string;
        };
      };
      statusChange: {
        activateButton: string;
        activateSuccess: string;
        cancelButton: string;
        cancelSuccess: string;
        completeButton: string;
        completeSuccess: string;
        error: string;
        label: string;
      };
      statusWarningsDialog: {
        activateButton: string;
        closeButton: string;
        subtitle: string;
        title: string;
      };
      steps: {
        developmentPlan: { comingSoon: string; description: string; title: string };
        knowledgeTest: {
          attachButton: string;
          attachDialog: {
            attachButton: string;
            attachError: string;
            attachingButton: string;
            attachSuccess: string;
            cancelButton: string;
            loading: string;
            noPools: string;
            questionCount: string;
            searchPlaceholder: string;
            title: string;
          };
          browseButton: string;
          config: {
            backNav: string;
            notConfigured: string;
            pass: string;
            questions: string;
          };
          description: string;
          detachButton: string;
          detachError: string;
          detachSuccess: string;
          emptyPools: string;
          initializeButton: string;
          manageParticipantsAndTerms: string;
          openConfig: string;
          poolsTitle: string;
          stageCreatedError: string;
          stageCreatedSuccess: string;
          stageNamePlaceholder: string;
          stageNotInitialized: string;
          stageParticipants: {
            addButton: string;
            addByEmployee: string;
            addByPosition: string;
            addBySap: string;
            addedHeader: string;
            addError: string;
            addPositionButton: string;
            addPositionCodesHelper: string;
            addPositionError: string;
            addPositionInvalidFormat: string;
            addPositionPlaceholder: string;
            addSapButton: string;
            addSapError: string;
            addSapHelper: string;
            addSapInvalidFormat: string;
            addSapPlaceholder: string;
            addSelectedButton: string;
            addSuccess: string;
            allInStageEmpty: string;
            emailHeader: string;
            filtersClear: string;
            filterStatus: string;
            filtersToggle: string;
            filterTerms: string;
            more: string;
            nameHeader: string;
            noParticipants: string;
            noParticipantsHint: string;
            noTerms: string;
            removeError: string;
            removeSuccess: string;
            removeTooltip: string;
            searchParticipantsPlaceholder: string;
            searchPlaceholder: string;
            showing: string;
            showLess: string;
            status: {
              ASSIGNED: string;
              EXPIRED: string;
              FAILED: string;
              PASSED: string;
              STARTED: string;
            };
            termHistoryHeader: string;
            title: string;
          };
          testTerms: {
            cancelButton: string;
            cancelledLabel: string;
            completeButton: string;
            completedLabel: string;
            createDialog: {
              cancelButton: string;
              createButton: string;
              createError: string;
              createSuccess: string;
              creatingButton: string;
              endHint: string;
              endLabel: string;
              nameLabel: string;
              nameMaxLength: string;
              namePlaceholder: string;
              nameRequired: string;
              startLabel: string;
              subtitle: string;
              title: string;
            };
            createFirstButton: string;
            editDialog: {
              cancelButton: string;
              endLabel: string;
              hint: string;
              nameLabel: string;
              namePlaceholder: string;
              nameRequired: string;
              saveButton: string;
              savingButton: string;
              startLabel: string;
              startLockedHelper: string;
              subtitle: string;
              title: string;
              updateError: string;
              updateSuccess: string;
            };
            extendTimeButton: string;
            extendTimeConfirm: string;
            extendTimeError: string;
            extendTimeHint: string;
            extendTimeLabel: string;
            extendTimeSuccess: string;
            extendTimeTitle: string;
            hideParticipants: string;
            inProgressLabel: string;
            newButton: string;
            newLabel: string;
            noTermsDescription: string;
            noTermsTitle: string;
            participants: string;
            participantsDialog: {
              activityReportError: string;
              activityReportTooltip: string;
              addButton: string;
              addError: string;
              addSelectedButton: string;
              addSuccess: string;
              allInTermEmpty: string;
              closeButton: string;
              emailHeader: string;
              noParticipants: string;
              noParticipantsHint: string;
              participantHeader: string;
              removeError: string;
              removeSuccess: string;
              removeTooltip: string;
              searchByNameEmail: string;
              searchPlaceholder: string;
              selectLabel: string;
              statusAssigned: string;
              statusExpired: string;
              statusFailed: string;
              statusHeader: string;
              statusPassed: string;
              statusStarted: string;
              subtitle: string;
              title: string;
              viewResultsTooltip: string;
            };
            resultsDialog: {
              closeButton: string;
              correctAnswerHeader: string;
              correctLabel: string;
              executionStatus: {
                COMPLETED_FAILED: string;
                COMPLETED_PASSED: string;
                EXPIRED: string;
                IN_PROGRESS: string;
                NOT_STARTED: string;
              };
              filterAll: string;
              filterCorrect: string;
              filterIncorrect: string;
              incorrectLabel: string;
              noAnswerLabel: string;
              questionHeader: string;
              sectionHeader: string;
              unansweredLabel: string;
              yourAnswerHeader: string;
            };
            resultsListDialog: {
              closeButton: string;
              correctHeader: string;
              noResults: string;
              noResultsHint: string;
              participantHeader: string;
              scoreHeader: string;
              searchPlaceholder: string;
              statusHeader: string;
              subtitle: string;
              title: string;
              viewDetailTooltip: string;
            };
            revertButton: string;
            revertSuccess: string;
            showParticipants: string;
            startBlockedReason: string;
            startBlockedStageInactiveReason: string;
            startButton: string;
            startCertificationDraftInfo: string;
            startExtensionInfo: string;
            startInFutureInfo: string;
            startInPastInfo: string;
            startStageDraftInfo: string;
            title: string;
            updatedAt: string;
            updateError: string;
            updateSuccess: string;
            viewParticipantsTooltip: string;
            viewResultsTooltip: string;
          };
          title: string;
          uploadButton: string;
          uploadToPoolButton: string;
        };
        practicalTest: {
          comingSoon: string;
          config: { notConfigured: string };
          description: string;
          examDays: string;
          initializeButton: string;
          openConfig: string;
          stageCreatedError: string;
          stageCreatedSuccess: string;
          stageNamePlaceholder: string;
          stageNotInitialized: string;
          title: string;
        };
        selfAssessment: { description: string; title: string };
      };
    };
    examStageConfig: {
      bar: {
        attemptsUnit: string;
        passPrefix: string;
        questionsUnit: string;
      };
      cancelButton: string;
      configureButton: string;
      confirmDialog: {
        cancel: string;
        confirm: string;
        title: string;
      };
      editButton: string;
      fields: {
        maxAttempts: string;
        maxQuestions: string;
        minQuestions: string;
        noLimit: string;
        ofQuestions: string;
        questionsCount: string;
        questionsShort: string;
        requiredToPass: string;
        timeLimitMinutes: string;
      };
      notConfigured: string;
      saveButton: string;
      validation: {
        maxAttempts: string;
        maxQuestions: string;
        minQuestions: string;
        questionsCount: string;
        requiredToPass: string;
      };
    };
    examStageDetail: {
      createExamDay: {
        cancelButton: string;
        createButton: string;
        fields: {
          chairman: string;
          date: string;
          hrbp: string;
          location: string;
        };
        title: string;
      };
      examDayDetail: {
        addParticipant: string;
        addParticipantDialog: {
          addedEmpty: string;
          addedTitle: string;
          addTooltip: string;
          allRegions: string;
          availableTitle: string;
          clearFilters: string;
          close: string;
          empty: string;
          noResults: string;
          regionLabel: string;
          searchPlaceholder: string;
          title: string;
        };
        cancelDay: string;
        cancelExam: string;
        chairman: string;
        columns: {
          actions: string;
          examStatus: string;
          name: string;
          result: string;
        };
        completeDay: string;
        dayStatus: Record<ExamDayStatusDto, string>;
        examsTitle: string;
        generateExams: string;
        noExam: string;
        noParticipants: string;
        participants: string;
        removeParticipant: string;
        startDay: string;
      };
      examDays: {
        addButton: string;
        backToList: string;
        cancelButton: string;
        chairman: string;
        completeButton: string;
        dayStatus: Record<ExamDayStatusDto, string>;
        empty: string;
        filters: {
          clear: string;
          commissionMember: string;
          dateFrom: string;
          dateTo: string;
          noResults: string;
          searchPlaceholder: string;
          toggle: string;
        };
        participantsCount: string;
        startBlockedStageInactiveReason: string;
        startButton: string;
        title: string;
        updateError: string;
      };
      examQuestion: {
        answerKeyLabel: string;
        chairmanComment: string;
        commentPlaceholder: string;
        hrbpComment: string;
        questionLabel: string;
        reportAreaLabel: string;
        reportLabel: string;
        reportShareNotSharedLabel: string;
        reportShareShareButton: string;
        reportShareSharedLabel: string;
        reportShareUnshareButton: string;
        reportTag: string;
        subquestionLabel: string;
        subquestionsTitle: string;
        verdictFail: string;
        verdictPass: string;
        verdictRejected: string;
      };
      individualExam: {
        cancelButton: string;
        carriedOver: {
          close: string;
          modalTitle: string;
          previewSourceTooltip: string;
          question: string;
          report: string;
          subtitle: string;
          title: string;
        };
        chairmanComment: string;
        changelog: string;
        createdAt: string;
        dayNotStarted: string;
        dayNotStartedDialogCancel: string;
        dayNotStartedDialogConfirm: string;
        dayNotStartedDialogMessage: string;
        dayNotStartedDialogTitle: string;
        editModeOff: string;
        editModeOn: string;
        examStatus: Record<IndividualExamStatusDto, string>;
        failed: string;
        finishButton: string;
        finishedAtLabel: string;
        generalComment: string;
        generalCommentPlaceholder: string;
        generalCommentVisibilityNotice: string;
        hrbpComment: string;
        infoAssignedQuestions: string;
        infoMinQuestions: string;
        infoQuestionsShort: string;
        infoRequiredToPass: string;
        infoTimeLimit: string;
        minRequired: string;
        notPassing: string;
        passed: string;
        passing: string;
        progress: string;
        questionsTitle: string;
        result: string;
        resultFailed: string;
        resultPassed: string;
        stage2AttemptsCount_few: string;
        stage2AttemptsCount_many: string;
        stage2AttemptsCount_one: string;
        stage2AttemptsCount_other: string;
        stage2Failed: string;
        stage2NotAvailable: string;
        stage2NoTerms: string;
        stage2Passed: string;
        stage2Result: string;
        stage2Status: {
          ABSENT: string;
          COMPLETED: string;
          FAILED: string;
          IN_PROGRESS: string;
          NOT_STARTED: string;
        };
        stage2TermsListTitle: string;
        stage2ViewAttemptsTooltip: string;
        stage2ViewTooltip: string;
        startButton: string;
        startedAtLabel: string;
        total: string;
      };
      label: string;
      loading: string;
      notInitialized: string;
      participants: {
        add: string;
        addButton: string;
        addByEmployee: string;
        addByPosition: string;
        addBySap: string;
        addedNoneNotFound: string;
        addedNoneTestNotPassed: string;
        addedSummaryWithSkipped: string;
        addedSummaryWithSkippedSap: string;
        addFromCertification: string;
        addPositionButton: string;
        addPositionCodesHelper: string;
        addPositionError: string;
        addPositionInvalidFormat: string;
        addPositionPlaceholder: string;
        addSapButton: string;
        addSapError: string;
        addSapHelper: string;
        addSapInvalidFormat: string;
        addSapPlaceholder: string;
        addSelectedButton: string;
        addSuccess: string;
        columns: {
          actions: string;
          addedAt: string;
          email: string;
          examStatus: string;
          name: string;
        };
        empty: string;
        filtersClear: string;
        filtersToggle: string;
        helpTooltip: string;
        noAvailableParticipants: string;
        noEligibleParticipants: string;
        removeTooltip: string;
        searchPlaceholder: string;
        title: string;
      };
      practicalAttempts: {
        abandonButton: string;
        abandonTooltip: string;
        attemptChip: string;
        attemptsUsed: string;
        completeButton: string;
        completeTooltip: string;
        detail: {
          answerKey: string;
          emptyAttempt: string;
          linkCopied: string;
          noAttachments: string;
          pdfPreviewError: string;
          pdfPreviewLoading: string;
          pdfPreviewPager: string;
          questions: string;
          reports: string;
          shareButton: string;
          shareError: string;
          title: string;
        };
        limitReached: string;
        maxAttempts: string;
        noParticipants: string;
        passed: string;
        startButton: string;
        startError: string;
        startSuccess: string;
        status: Record<PracticalExamAttemptStatusDto, string>;
        statusUpdateError: string;
        statusUpdateSuccess: string;
        title: string;
      };
      questionPools: {
        attachButton: string;
        browseTooltip: string;
        detachError: string;
        detachSuccess: string;
        detachTooltip: string;
        empty: string;
        poolCount: string;
        questionsCount: string;
        title: string;
        uploadButton: string;
        uploadToPoolTooltip: string;
      };
      questions: {
        addButton: string;
        cancelButton: string;
        columns: {
          actions: string;
          answerKey: string;
          question: string;
        };
        empty: string;
        fields: {
          answerKey: string;
          questionText: string;
        };
        generateSample: string;
        removeTooltip: string;
        saveButton: string;
        searchPlaceholder: string;
        title: string;
      };
      tabs: {
        attempts: string;
        config: string;
        examDays: string;
        examDaysLockedReason: string;
        participants: string;
        questions: string;
      };
      title: string;
    };
    examStageStatus: Record<ExamStageStatusDto, string>;
    filters: {
      allStatuses: string;
      searchButton: string;
      searchPlaceholder: string;
      status: string;
    };
    formDialog: {
      cancelButton: string;
      clearDeadline: string;
      createButton: string;
      createError: string;
      createSuccess: string;
      createTitle: string;
      deadlineHelp: string;
      deadlineLabel: string;
      deadlinePastConfirm: string;
      deadlinePastWarning: string;
      deadlineValidation: string;
      description: string;
      descriptionMaxLength: string;
      editTitle: string;
      nameLabel: string;
      nameMaxLength: string;
      nameRequired: string;
      saveButton: string;
      savingButton: string;
      status: string;
      updateError: string;
      updateSuccess: string;
    };
    itemRow: {
      createdAt: string;
      deleteDisabledTooltip: string;
      deleteTooltip: string;
      openTooltip: string;
    };
    loadError: string;
    loading: string;
    newButton: string;
    practicalExam: {
      attachDialog: {
        attachButton: string;
        attachError: string;
        attachingButton: string;
        attachSuccess: string;
        cancelButton: string;
        noPools: string;
        questionCount: string;
        searchButton: string;
        searchPlaceholder: string;
        title: string;
      };
      poolCard: {
        detachButton: string;
        questionsLabel: string;
        showQuestions: string;
        uploadToPoolButton: string;
      };
      questionsBrowser: {
        addAttachmentButton: string;
        answerKeyLabel: string;
        areaAll: string;
        attachmentDeleteError: string;
        attachmentDeleteSuccess: string;
        attachmentsLabel: string;
        deleteAttachment: string;
        downloadAttachment: string;
        globalPassLabel: string;
        globalPassTooltip: string;
        noAttachments: string;
        noQuestions: string;
        noReports: string;
        previewAttachment: string;
        previewCloseButton: string;
        questionsSection: string;
        reportChipLabel: string;
        reportsSection: string;
        searchPlaceholder: string;
        subquestionsLabel: string;
      };
      reportAttachmentDialog: {
        cancelButton: string;
        chooseFileButton: string;
        dragDropText: string;
        errorToast: string;
        fileLabel: string;
        fileRequired: string;
        fileTooLarge: string;
        hint: string;
        invalidFileType: string;
        successToast: string;
        title: string;
        uploadButton: string;
        uploadingButton: string;
      };
      uploadPoolDialog: {
        appendTitle: string;
        cancelButton: string;
        chooseFileButton: string;
        dragDropText: string;
        errorToast: string;
        fileLabel: string;
        fileRequired: string;
        formatColumns: string;
        formatTitle: string;
        formatTypes: string;
        nameHelp: string;
        nameLabel: string;
        successToast: string;
        title: string;
        uploadButton: string;
        uploadingButton: string;
        validationErrorsTitle: string;
      };
      uploadToExistingPoolDialog: {
        cancelButton: string;
        chooseFileButton: string;
        dragDropText: string;
        errorToast: string;
        fileLabel: string;
        fileRequired: string;
        successToast: string;
        title: string;
        uploadButton: string;
        uploadingButton: string;
        validationErrorsTitle: string;
      };
    };
    questionPools: {
      filters: {
        allTypes: string;
        search: string;
        searchPlaceholder: string;
      };
      table: {
        actions: string;
        browseButton: string;
        createdAt: string;
        name: string;
        noData: string;
        questionCount: string;
        rowsPerPage: string;
        type: string;
        uploadButton: string;
      };
      title: string;
    };
    questionsBrowser: {
      explanationLabel: string;
      noResults: string;
      questionCount: string;
      rankLabel: string;
      searchPlaceholder: string;
      sectionPlaceholder: string;
      singleChoiceLabel: string;
      tabPool: string;
      tabStage: string;
      title: string;
      typeAll: string;
      typeRank: string;
      typeSingleChoice: string;
    };
    status: Record<CertificationStatusDto, string>;
    stepCard: {
      configured: string;
      instructionsTooltip: string;
      notConfigured: string;
      stepLabel: string;
    };
    stepLabels: {
      comingSoon: string;
      devPlan: string;
      knowledgeTest: string;
      notConfigured: string;
      participants: string;
      practicalTest: string;
      selfAssessment: string;
    };
    summary: {
      active: string;
      completed: string;
      draft: string;
      total: string;
    };
    surveyStep: {
      activationDialog: {
        cancel: string;
        confirm: string;
        description: string;
        error: string;
        itemCertification: string;
        itemStage: string;
        success: string;
        title: string;
      };
      assignExisting: string;
      changeButton: string;
      changeSurveyTooltip: string;
      createNew: string;
      deadlineLabel: string;
      deadlinePastTooltip: string;
      detachButton: string;
      detachSurveyTooltip: string;
      noParticipants: string;
      noSurveyDescription: string;
      noSurveyTitle: string;
      participants: string;
      startDisabledTooltip: string;
      status: {
        ACTIVE: string;
        CANCELLED: string;
        COMPLETED: string;
        DRAFT: string;
      };
      statusAction: {
        cancel: string;
        complete: string;
        start: string;
      };
    };
    table: {
      actions: string;
      createdBy: string;
      deadline: string;
      name: string;
      noData: string;
      status: string;
      steps: string;
    };
    testStageConfig: {
      activateBlockedReason: string;
      bar: {
        passPrefix: string;
        questionsUnit: string;
        resultVisibilityWindow: string;
      };
      cancelButton: string;
      configureButton: string;
      editButton: string;
      fields: {
        allowBackNavigation: string;
        backNavEnabled: string;
        noLimit: string;
        numberOfQuestions: string;
        passingThreshold: string;
        resultVisibility: string;
        resultVisibilityWindowMinutes: string;
        resultVisibilityWindowMinutesHint: string;
        timeExtensionHint: string;
        timeExtensionMinutes: string;
        timeLimitMinutes: string;
      };
      label: string;
      notConfigured: string;
      pools: {
        attachButton: string;
        attachError: string;
        browseButton: string;
        detachBlockedByActiveTerm: string;
        detachButton: string;
        detachError: string;
        none: string;
        poolCount: string;
        poolQuestionCount: string;
        questionsLabel: string;
        title: string;
        uploadButton: string;
        uploadToPoolButton: string;
      };
      resultVisibilityOptions: {
        none: string;
        resultOnly: string;
        resultWithQuestions: string;
        resultWithScore: string;
      };
      saveButton: string;
      saveError: string;
      saveSuccess: string;
      sections: {
        available: string;
        exceedsAvailable: string;
        none: string;
        title: string;
        total: string;
        totalLabel: string;
      };
    };
    testStageDetail: {
      backButton: string;
      label: string;
      loading: string;
      notFound: string;
      notInitialized: string;
      subtitle: string;
      tabs: {
        config: string;
        configLockedReason: string;
        participants: string;
        participantsLockedReason: string;
        pools: string;
        terms: string;
        termsLockedReason: string;
      };
      title: string;
    };
    title: string;
    uploadPoolDialog: {
      appendTitle: string;
      cancelButton: string;
      chooseFileButton: string;
      dragDropText: string;
      errorToast: string;
      fileLabel: string;
      fileRequired: string;
      nameHelp: string;
      nameLabel: string;
      successToast: string;
      title: string;
      uploadButton: string;
      uploadingButton: string;
      validationErrorsTitle: string;
    };
    uploadToExistingPoolDialog: {
      cancelButton: string;
      chooseFileButton: string;
      dragDropText: string;
      errorToast: string;
      fileLabel: string;
      fileRequired: string;
      successToast: string;
      title: string;
      uploadButton: string;
      uploadingButton: string;
      validationErrorsTitle: string;
    };
  };
  changeHistory: {
    filters: {
      action: string;
      actions: {
        activate: string;
        assign: string;
        create: string;
        deactivate: string;
        delete: string;
        toggleOverride: string;
        unassign: string;
        update: string;
      };
      all: string;
      changedAfter: string;
      changedBefore: string;
      changedByUserEmail: string;
      changeType: string;
      changeTypes: {
        permissionEdit: string;
        roleEdit: string;
        rolePermissionAssignment: string;
        userPermissionChange: string;
        userRoleChange: string;
      };
      clearFilters: string;
      targetUserEmail: string;
    };
    table: {
      actions: {
        ACTIVATE: string;
        ASSIGN: string;
        CREATE: string;
        DEACTIVATE: string;
        DELETE: string;
        TOGGLE_OVERRIDE: string;
        UNASSIGN: string;
        UPDATE: string;
      };
      changeTypes: {
        PERMISSION_EDIT: string;
        ROLE_EDIT: string;
        ROLE_PERMISSION_ASSIGNMENT: string;
        USER_PERMISSION_CHANGE: string;
        USER_ROLE_CHANGE: string;
      };
      error: string;
      fieldName: string;
      headers: {
        action: string;
        changedAt: string;
        changedBy: string;
        changeType: string;
        description: string;
        id: string;
        permission: string;
        role: string;
        targetUser: string;
      };
      loading: string;
      newValue: string;
      noData: string;
      oldValue: string;
      rowsPerPage: string;
    };
  };
  confirmPermissionAction: {
    actions: {
      activatePermission: { description: string; title: string; warning: string };
      addIndividualPermission: { description: string; title: string; warning: string };
      addRoleToUser: { description: string; title: string; warning: string };
      assignPermissionToRole: { description: string; title: string; warning: string };
      deactivatePermission: { description: string; title: string; warning: string };
      deactivateRolePermission: { description: string; title: string; warning: string };
      removeIndividualPermission: { description: string; title: string; warning: string };
      removePermissionFromRole: { description: string; title: string; warning: string };
      removeRoleFromUser: { description: string; title: string; warning: string };
      toggleRole: { description: string; title: string; warning: string };
    };
    cancel: string;
    confirm: string;
  };
  dictionaries: {
    editDialog: {
      active: string;
      cancel: string;
      englishName: string;
      polishName: string;
      save: string;
      saving: string;
      title: string;
    };
    filters: {
      active: string;
      allStatuses: string;
      allTypes: string;
      inactive: string;
      name: string;
      searchByName: string;
      status: string;
      type: string;
    };
    table: {
      actions: string;
      code: string;
      edit: string;
      englishName: string;
      noData: string;
      noFilters: string;
      polishName: string;
      rowsPerPage: string;
      status: {
        false: string;
        true: string;
      };
      statusHeader: string;
      type: string;
    };
    title: string;
  };
  employeesList: {
    buttons: {
      export: string;
    };
    content: {
      table: {
        active: string;
        email: string;
        externalEmployeeId: string;
        firstName: string;
        inactive: string;
        lastName: string;
      };
    };
    dialog: {
      cancel: string;
      confirm: string;
      message: string;
      title: string;
    };
    form: {
      externalEmployeeId: string;
      firstName: string;
      lastName: string;
    };
  };
  groups: {
    certification: string;
    content: string;
    management: string;
    tools: string;
  };
  impersonation: {
    blockedDisabled: string;
    blockedNoRole: string;
    blockedPrivileged: string;
    noEmployeeRecordChip: string;
    noRoleChip: string;
    privilegedChip: string;
  };
  news: {
    actions: {
      archive: string;
      backToDraft: string;
      cancel: string;
      delete: string;
      edit: string;
      error: string;
      preview: string;
      publish: string;
    };
    categories: Record<NewsCategoryDto, string>;
    confirmations: {
      archive: { confirm: string; message: string; title: string };
      delete: { confirm: string; message: string; title: string };
      draft: { confirm: string; message: string; title: string };
      publish: { confirm: string; message: string; title: string };
    };
    editor: {
      cancel: string;
      categoryLabel: string;
      categoryRequired: string;
      changeImage: string;
      chooseImage: string;
      contentHelp: string;
      contentLabel: string;
      createError: string;
      createTitle: string;
      editTitle: string;
      imageClear: string;
      imageDropActive: string;
      imageDropReplace: string;
      imageDropSubtitle: string;
      imageDropTitle: string;
      imageHelp: string;
      imageLabel: string;
      imageSelected: string;
      imageSizeError: string;
      imageTypeError: string;
      loading: string;
      publishNow: string;
      save: string;
      saveChanges: string;
      saveDraft: string;
      saving: string;
      subtitle: string;
      titleLabel: string;
      titleMaxLength: string;
      titlePlaceholder: string;
      titleRequired: string;
      toolbar: {
        bold: string;
        image: string;
        italic: string;
        link: string;
        linkDialog: { apply: string; cancel: string; title: string };
        orderedList: string;
        underline: string;
        unorderedList: string;
        video: string;
      };
      untitledDraft: string;
      updateError: string;
      videoProcessing: string;
      videoTypeError: string;
    };
    empty: {
      title: string;
    };
    filters: {
      allCategories: string;
      allStatuses: string;
      category: string;
      searchPlaceholder: string;
      status: string;
    };
    newButton: string;
    preview: {
      close: string;
      emptyContent: string;
      subtitle: string;
      title: string;
      videoError: string;
    };
    statuses: Record<NewsStatusDto, string>;
    subtitle: string;
    table: {
      actions: string;
      category: string;
      createdAt: string;
      error: string;
      loading: string;
      noData: string;
      noImage: string;
      publishedAt: string;
      rowsPerPage: string;
      status: string;
      title: string;
      updatedAt: string;
    };
    title: string;
  };
  noPermissions: string;
  permissionDetails: {
    active: string;
    category: string;
    code: string;
    description: string;
    inactive: string;
    name: string;
    noDescription: string;
    status: string;
    title: string;
  };
  permissionsEmployees: {
    backToList: string;
    columns: {
      department: string;
      email: string;
      employee: string;
      sap: string;
      status: string;
    };
    description: string;
    detail: {
      activate: string;
      allWithCount: string;
      assignedPermissions: string;
      assignedRoles: string;
      availablePermissions: string;
      availableRoles: string;
      categoryNone: string;
      categoryUncategorized: string;
      deactivate: string;
      fromRole: string;
      hrbpTitle: string;
      individualPermissions: string;
      noAssignedPermissions: string;
      noAssignedRoles: string;
      noAvailablePermissions: string;
      noAvailableRoles: string;
      noPermissionsMatch: string;
      noResults: string;
      noRolePermissions: string;
      permissionCount: string;
      permissionsTitle: string;
      roleDisableSuffix: string;
      roleEnableSuffix: string;
      rolePermissions: string;
      rolesTitle: string;
      searchByNameOrCode: string;
      statusActive: string;
      statusDisabled: string;
      systemBadge: string;
      systemRolesInfoBody: string;
      systemRolesInfoTitle: string;
      toast: {
        bulkPartial: string;
        cannotRemoveSystemRole: string;
        individualsAdded: string;
        individualsAddError: string;
        individualsRemoved: string;
        individualsRemoveError: string;
        noRolesSelected: string;
        permissionActivated: string;
        permissionActivatedForRoles: string;
        permissionDeactivated: string;
        permissionDeactivatedForRoles: string;
        permissionUpdateError: string;
        roleAdded: string;
        roleAddError: string;
        roleDisabled: string;
        roleEnabled: string;
        roleNotFoundForPermission: string;
        rolePermissionUpdateError: string;
        roleRemoved: string;
        roleRemoveError: string;
        roleUpdateError: string;
      };
    };
    emptyResultsDescription: string;
    emptyResultsTitle: string;
    loading: string;
    onlyModified: string;
    rowsPerPage: string;
    searchPlaceholder: string;
    startDescription: string;
    startTitle: string;
    statusModified: string;
    title: string;
  };
  permissionsTable: {
    active: string;
    allCategories: string;
    columnActions: string;
    columnCategory: string;
    columnCode: string;
    columnDescription: string;
    columnName: string;
    columnStatus: string;
    count: string;
    deleteCentralInfo: string;
    editCentralInfo: string;
    emptyDescription: string;
    emptyFilteredDescription: string;
    emptyFilteredTitle: string;
    emptyTitle: string;
    inactive: string;
    loading: string;
    searchPlaceholder: string;
    toggleError: string;
    toggleSuccess: string;
  };
  professionalActivityDefinitions: {
    documents: {
      aiContext: string;
      aiContextTooltip: string;
      deleteDialog: {
        cancel: string;
        confirm: string;
        message: string;
        title: string;
      };
      dropzoneHintPrefix: string;
      dropzoneLabel: string;
      dropzoneMaxSize: string;
      embeddingStatus: {
        available: string;
        failed: string;
        noContent: string;
        notEmbedded: string;
        processing: string;
      };
      empty: string;
      loading: string;
      reembed: string;
      title: string;
    };
    editDialog: {
      cancel: string;
      description: string;
      developmentProgram: string;
      editYear: string;
      name: string;
      save: string;
      saving: string;
      status: string;
      statusValues: {
        COMPLETED: string;
        IN_PROGRESS: string;
        PLANNED: string;
      };
      title: string;
    };
    searchPlaceholder: string;
    table: {
      description: string;
      developmentProgram: string;
      editYear: string;
      name: string;
      noData: string;
      rowsPerPage: string;
      status: string;
      statusValues: {
        COMPLETED: string;
        IN_PROGRESS: string;
        PLANNED: string;
      };
      updatedAt: string;
    };
    title: string;
  };
  ragDocuments: {
    form: {
      fields: {
        categories: {
          label: string;
          placeholder: string;
        };
        description: {
          label: string;
        };
        file: {
          accepted: string;
          dropzoneLabel: string;
          remove: string;
        };
        tags: {
          label: string;
          placeholder: string;
        };
        title: {
          label: string;
        };
      };
      status: {
        awaitingValidationResolution: string;
        close: string;
        error: string;
        finished: string;
        inProgress: string;
        notStarted: string;
        processing: string;
        readingDocument: string;
        validationFailed: string;
      };
      submitButton: string;
      submitButtonLoading: string;
      title: string;
      toasts: {
        initError: string;
        sseError: string;
        uploadError: string;
        uploadSuccess: string;
      };
    };
  };
  roleAssignments: {
    allWithCount: string;
    assignAriaLabel: string;
    assignedTitle: string;
    assignError: string;
    assignSuccess: string;
    availableTitle: string;
    categoryWithCount: string;
    confirmDetails: string;
    count: string;
    emptyAssigned: string;
    emptyAvailable: string;
    emptyFiltered: string;
    noRoles: string;
    removeAriaLabel: string;
    removeError: string;
    removeSuccess: string;
    rolePlaceholder: string;
    rolesTitle: string;
    searchPlaceholder: string;
    selectAll: string;
    selectedCount: string;
  };
  roleForm: {
    cancel: string;
    colorHint: string;
    colorLabel: string;
    createTitle: string;
    descriptionLabel: string;
    editTitle: string;
    nameLabel: string;
    save: string;
  };
  roles: {
    badgePermissions: string;
    badgePermissionsSystem: string;
    count: string;
    emptyDescription: string;
    emptySearchDescription: string;
    emptySearchTitle: string;
    emptyTitle: string;
    loading: string;
    searchPlaceholder: string;
    updateError: string;
    updateSuccess: string;
  };
  sections: {
    accounts: {
      description: string;
    };
    data: {
      historyDescription: string;
      historyTitle: string;
      uploadDescription: string;
      uploadTitle: string;
    };
    developmentCycles: {
      activeChip: string;
      applyToAllChip: string;
      cancelCampaign: {
        cancel: string;
        confirm: string;
        description: string;
        notice: string;
        title: string;
      };
      delete: {
        cancel: string;
        confirm: string;
        description: string;
        title: string;
      };
      description: string;
      fields: {
        covered: string;
        coveredAll: string;
        coveredEmpty: string;
        name: string;
        noName: string;
        tasksStartDate: string;
        window: string;
      };
      form: {
        active: string;
        activeHint: string;
        applyToAll: string;
        applyToAllHint: string;
        applyToAllNotice: string;
        cancel: string;
        createTitle: string;
        cycleValidFrom: string;
        cycleValidTo: string;
        editTitle: string;
        errors: {
          conflict: string;
          generic: string;
          tasksStartDate: string;
          window: string;
        };
        name: string;
        namePlaceholder: string;
        sapImport: {
          clearConfirmAction: string;
          clearConfirmBody: string;
          clearConfirmTitle: string;
          clearList: string;
          dropzoneBottom: string;
          dropzoneTop: string;
          errorTooMany: string;
          errorUnreadable: string;
          fileHint: string;
          modeAppend: string;
          modeBody: string;
          modeCancel: string;
          modeReplace: string;
          modeTitle: string;
          rejectedRow: string;
          rejectedTitle: string;
          showAll: string;
          showLess: string;
          summaryDuplicates: string;
          summarySuccess: string;
        };
        save: string;
        targetSaps: string;
        targetSapsAdd: string;
        targetSapsEmpty: string;
        targetSapsHint: string;
        targetSapsPlaceholder: string;
        tasksStartDate: string;
      };
      impact: {
        activation: string;
        activeEdit: string;
        cancel: string;
        confirm: string;
        deactivation: string;
        title: string;
      };
      inactiveChip: string;
      members: {
        back: string;
        detail: {
          back: string;
          cycleCampaign: string;
          cycleDirection: string;
          cycleState: string;
          cycleWindow: string;
          noAccount: string;
          noPlans: string;
          noPlansTitle: string;
          noTaskReason: string;
          noTasks: string;
          noTasksTitle: string;
          p1: string;
          pageDescription: string;
          pageTitle: string;
          plansTitle: string;
          taskDeadline: string;
          taskDescription: string;
          taskStatus: string;
          tasksTitle: string;
          taskTarget: string;
          taskTrigger: string;
          thisCampaign: string;
        };
        emptyDescription: string;
        emptyTitle: string;
        error: string;
        errorTitle: string;
        filters: {
          anyPlanStatus: string;
          planStatusLabel: string;
          searchPlaceholder: string;
          withoutAccount: string;
          withoutTask: string;
        };
        no: string;
        pageDescription: string;
        pageTitle: string;
        planStatus: {
          ARCHIVED: string;
          CANCELLED: string;
          COMPLETED: string;
          DRAFT: string;
          NONE: string;
          READY_FOR_REALIZATION: string;
          SUPERVISOR_APPROVED: string;
          SUPERVISOR_REJECTED: string;
        };
        reason: {
          BEFORE_TASKS_START: string;
          CATCH_ALL: string;
          NO_USER_ACCOUNT: string;
          PENDING_SCAN: string;
          PLAN_EXISTS: string;
        };
        source: {
          APPLY_TO_ALL: string;
          TARGETED: string;
        };
        summary: {
          covered: string;
          withOpenTask: string;
          withPlan: string;
          withUserAccount: string;
        };
        table: {
          account: string;
          name: string;
          p1: string;
          plan: string;
          source: string;
          task: string;
        };
        taskType: {
          PLAN_INITIATION: string;
          PLAN_REQUIRED: string;
        };
        yes: string;
      };
      noActiveCampaign: string;
      sweep: {
        button: string;
        description: string;
        result: string;
        testBadge: string;
        title: string;
      };
      table: {
        actions: string;
        cancelAction: string;
        covered: string;
        coveredAll: string;
        coveredEmpty: string;
        createButton: string;
        deleteAction: string;
        editAction: string;
        empty: string;
        emptyTitle: string;
        members: string;
        membersAction: string;
        name: string;
        status: string;
        tasksStartDate: string;
        title: string;
        window: string;
      };
    };
    employees: {
      description: string;
    };
    permissions: {
      description: string;
    };
  };
  sidebar: {
    backToStart: string;
    collapseAriaLabelCollapsed: string;
    collapseAriaLabelExpanded: string;
    subtitle: string;
  };
  successionPermissions: {
    comingSoon: string;
    description: string;
    errors: {
      loadingData: string;
      loadingUnits: string;
    };
    loading: {
      data: string;
      units: string;
    };
    messages: {
      hrbpHqInfo: string;
      noDataForSelectedUnits: string;
      saving: string;
      selectUnits: string;
    };
    table: {
      headers: {
        employeeCount: string;
        unitPosition: string;
      };
    };
    unitSelection: {
      allButton: string;
      clearAllButton: string;
      label: string;
      moreChipLabel: string;
      placeholder: string;
      remainingUnitsTooltip: string;
    };
  };
  surveyDetail: {
    backButton: string;
    backToCertification: string;
    backToSurveys: string;
    createdAt: string;
    createdBy: string;
    deadline: string;
    editButton: string;
    label: string;
    overview: {
      areas: string;
      categories: string;
      categoryLink: string;
      closedQuestions: string;
      negative: string;
      noCategoriesFound: string;
      openQuestions: string;
      positive: string;
      procedureDescription: string;
      procedureName: string;
      questions: string;
      scale: string;
      searchCategories: string;
      selectCategoryPrompt: string;
      threshold: string;
      total: string;
    };
    participants: {
      actions: string;
      answers: {
        allAreas: string;
        allCategories: string;
        answer: string;
        answerDuration: string;
        areaFilter: string;
        categoryFilter: string;
        error: string;
        loading: string;
        noData: string;
        questionNumber: string;
        report: {
          downloadButton: string;
          downloading: string;
          error: string;
          reportType: {
            EMPLOYEE_SURVEY_ANSWERS: string;
          };
          subtitle: string;
          title: string;
        };
        rowsPerPage: string;
        searchPlaceholder: string;
        summary: {
          allCategoriesMet: string;
          categoriesCount: string;
          competencyWorkRequired: string;
          goToResources: string;
          greatJob: string;
          howToImprove: string;
          loading: string;
          procedureDescription: string;
          procedureName: string;
          questionNumber: string;
          supportMaterials: string;
          viewAnswers: string;
        };
        tabAnswers: string;
        tabReport: string;
        tabSummary: string;
        title: string;
        totalAnswers: string;
      };
      assignedAt: string;
      completedAt: string;
      dates: string;
      details: string;
      email: string;
      hasSurveyAssigned: string;
      name: string;
      notificationSent: string;
      position: string;
      search: string;
      startedAt: string;
      status: Record<SurveyAssignmentStatusDto, string> & { all: string; null: string };
      statusLabel: string;
      table: {
        actions: string;
        error: string;
        loading: string;
        noData: string;
        rowsPerPage: string;
      };
      viewAnswers: string;
    };
    questions: {
      all: string;
      area: string;
      assignedTo: string;
      category: string;
      categoryDetails: string;
      categoryLink: string;
      employee: string;
      filters: string;
      group: string;
      position: string;
      procedureDescription: string;
      procedureName: string;
      total: string;
      type_CLOSED: string;
      type_OPEN: string;
    };
    reports: {
      download: string;
      downloading: string;
      error: string;
      reportType: {
        EMPLOYEE_SURVEY_ANSWERS: string;
      };
      subtitle: string;
    };
    status: string;
    statusAction: {
      cancel: string;
      complete: string;
      start: string;
    };
    statusUpdateError: string;
    statusUpdateSuccess: string;
    tabs: {
      overview: string;
      participants: string;
      questions: string;
      reports: string;
    };
  };
  surveys: {
    addButton: string;
    dialog: {
      cancel: string;
      deadline: string;
      deadlineHelp: string;
      dragDropText: string;
      file: string;
      fileHelp: string;
      name: string;
      save: string;
      saving: string;
      title: string;
      uploadSuccess: string;
    };
    editDialog: {
      cancel: string;
      deadline: string;
      deadlineHelp: string;
      name: string;
      nameRequired: string;
      save: string;
      saving: string;
      status: string;
      title: string;
      updateError: string;
      updateSuccess: string;
    };
    filters: {
      search: string;
    };
    status: {
      ACTIVE: string;
      CANCELLED: string;
      COMPLETED: string;
      DRAFT: string;
    };
    statusUpdateError: string;
    statusUpdateSuccess: string;
    table: {
      actions: string;
      author: string;
      createdAt: string;
      deadline: string;
      details: string;
      edit: string;
      error: string;
      loading: string;
      name: string;
      noData: string;
      participants: string;
      report: string;
      rowsPerPage: string;
      status: string;
    };
    title: string;
  };
  tabs: {
    accountsManagement: string;
    certificationSubTabs: {
      certification: string;
      questionPools: string;
      surveys: string;
    };
    changeHistory: string;
    dataManagement: string;
    dataManagementUpload: string;
    developmentCycles: string;
    devPlanTester: string;
    dictionaries: string;
    employeesManagement: string;
    impersonation: string;
    news: string;
    permissions: string;
    permissionSubTabs: {
      assignments: string;
      employees: string;
      hrbpPermissions: string;
      permissions: string;
      roles: string;
    };
    professionalActivityDefinitions: string;
    ragDocuments: string;
    successionPermissions: string;
    surveys: string;
    taskCreator: string;
  };
  taskCreator: {
    creating: string;
    deadline: string;
    description: string;
    error: string;
    resourceType: Record<ResourceTypeDto, string>;
    sourceResourceType: string;
    sourceResourceValue: string;
    submit: string;
    subtitle: string;
    targetResourceType: string;
    targetResourceValue: string;
    title: string;
  };
  title: string;
};

type StageInstructionBody = {
  adminSteps: string;
  employeeView: string;
  purpose: string;
  rules: string;
  transition: string;
};

export const adminPanelTranslation: AdminPanelTranslation = {
  certifications: {
    adminInstructions: {
      closeButton: 'Close',
      drawerTitle: 'Admin Instructions',
      sectionTitles: {
        adminSteps: 'What the admin does',
        employeeView: 'What the employee sees and when',
        purpose: 'Stage purpose',
        rules: 'Rules',
        transition: 'Moving to the next stage',
      },
      stages: {
        exam: {
          adminSteps:
            '1. Initialize the stage — give it a name and create the practical exam record.\n\n2. Configure the exam — add questions/tasks, set the pass threshold and duration.\n\n3. Create exam days — schedule dates and time slots in which individual exams take place.\n\n4. Assign participants to exam days and specific slots. Only assigned participants can take the exam.\n\n5. During the exam, the examiner evaluates the task performance directly in the system.\n\n6. Change the stage status (Draft → Active → Completed) using the action button in the top-right corner of the stage card.',
          employeeView:
            'The employee sees the practical exam stage only when the stage status is "Active" and they are assigned to an exam day.\n\nIn the employee panel, the exam term is visible (date, time, location) along with the assigned examiner.\n\nAfter the exam, the employee sees their result and status (passed / failed) once the examiner completes the evaluation.',
          purpose:
            "The practical exam verifies the employee's skills in real professional tasks. It's the final step confirming actual competence — the theory from the knowledge test must translate into practice.",
          rules:
            'The practical exam is conducted by a designated examiner who evaluates task performance.\n\nThe participant must be assigned to a specific exam day in order to take it.\n\nThe exam result (pass/fail) is determined by the examiner and is not automatically calculated.\n\nThe stage can have status: Not initialized, Not started, In progress, Completed.',
          transition:
            'Successful completion of the practical exam is a condition for obtaining the certification. Once the stage is completed, the system records the employee as certified.\n\nThe next step (when available) is the Development Plan, generated based on gaps identified in the previous stages.',
        },
        plan: {
          adminSteps:
            'The Development Plan feature is under construction. Once available, the admin will be able to:\n\n1. Generate a development plan based on gaps identified in self-assessment, knowledge test and practical exam.\n\n2. Assign concrete development actions to the employee (trainings, tasks, mentoring).\n\n3. Monitor progress and close individual activities.',
          employeeView:
            'Once the feature is released, the employee will see their individual development plan with a list of recommended actions, deadlines and completion status for each task.',
          purpose:
            'The Development Plan is the post-exam stage — based on it, the employee receives individual guidance for further competence development. This stage closes the certification process and initiates employee growth in the areas where gaps were detected.',
          rules:
            "The Development Plan stage is currently unavailable (feature in progress).\n\nOnce released, the plan will be generated based on results from earlier stages and the employee's history.",
          transition:
            'The Development Plan is the last step of the certification process. Upon its completion, the entire employee certification process is closed.',
        },
        survey: {
          adminSteps:
            '1. Assign a survey to the certification — you can pick an existing one or create a new one in the "Assign survey" dialog.\n\n2. Set a completion deadline (optional) — employees will see the deadline in their panel.\n\n3. Track progress in the Participants section — you see who has completed the survey and who hasn\'t.\n\n4. If needed, detach the survey ("Detach" button) — note: existing answers are then lost.',
          employeeView:
            'The employee sees the survey in their panel the moment they are assigned as a certification participant and a self-assessment survey is attached to the certification.\n\nThey fill it in before starting the knowledge test — answers are saved and used to identify competence gaps.\n\nIf a deadline is set, the employee sees it along with reminder notifications.',
          purpose:
            'Self-assessment is the first step of the certification process. It lets the employee assess their own competence level before formal verification. This establishes a baseline and identifies areas needing development.',
          rules:
            "Self-assessment is a survey completed by the employee — it's not scored by the admin.\n\nOnly one survey can be attached to a given certification at a time.\n\nDetaching the survey removes its link to the certification, but employee answers are preserved in the system.",
          transition:
            'Self-assessment does not block progression to the next stage — completing it is recommended but not a hard prerequisite for launching the knowledge test.\n\nNext step: Knowledge Test (stage 2).',
        },
        test: {
          adminSteps:
            '1. Initialize the stage — create the knowledge test stage record (give it a name, e.g. "Knowledge Test Q2 2026").\n\n2. Configure the test: attach question pools, set number of questions, pass threshold (e.g. 70%) and duration.\n\n3. Create test terms ("New term") — each term is a specific session date and time. End time is computed automatically from the configured duration.\n\n4. Assign participants to the stage (by employee, SAP or position code), then to specific terms.\n\n5. Activate the stage (Draft → Active) — only then do employees see the test in their panel. Activation requires at least one term.\n\n6. If needed, extend the time of an individual term ("Extend time" button) for participants with additional needs.',
          employeeView:
            'The employee sees the test in their panel when:\n- the stage has status "Active",\n- the employee is assigned to the stage and to a specific term,\n- the term\'s start time has arrived.\n\nBefore the term starts, the employee only sees information about the scheduled session (name, date, time).\n\nOnce started, they can take the test — they have a set time to answer. After finishing, they see their result (pass/fail) and score, if configuration allows.',
          purpose:
            'The Knowledge Test is a formal verification of theoretical understanding of the certification topic. The employee answers randomly drawn questions from attached pools and must reach the set threshold to move on to the practical exam.',
          rules:
            'The test is available only within a scheduled term (time window).\n\nQuestions are drawn randomly from attached pools according to the configured count.\n\nPassing requires reaching a percentage threshold (configurable at the stage level).\n\nTerm status: New → In progress → Completed. Terms can be cancelled before they start.\n\nStage status: Draft (configuring), Active (available to employees), Completed (finished), Cancelled.',
          transition:
            'Passing the Knowledge Test is a condition for taking the Practical Exam (stage 3). Employees with a "Failed" result are not automatically moved forward — the admin decides whether they retake a future term.',
        },
      },
      stepPrefix: 'Step',
    },
    assignSurveyDialog: {
      assignError: 'Failed to assign survey',
      assignExistingTab: 'Assign existing',
      assignSuccess: 'Survey assigned successfully',
      chooseFileButton: 'Choose file',
      clearDeadline: 'Clear deadline',
      closeButton: 'Close',
      createAssignButton: 'Create & Assign',
      createError: 'Failed to create survey',
      createNewTab: 'Create new',
      creatingButton: 'Creating...',
      currentlyAssigned: 'Currently assigned:',
      deadlineHelp: 'Optional deadline for participants',
      deadlineLabel: 'Deadline',
      deadlinePastWarning: 'Deadline is in the past',
      deadlineValidation: 'Deadline must be today or in the future',
      detachButton: 'Detach',
      detachError: 'Failed to detach survey',
      detachSuccess: 'Survey detached successfully',
      dragDropText: 'Drag & drop or click to select .xlsx file',
      fileLabel: 'File (XLSX) *',
      fileRequired: 'File is required',
      nameMaxLength: 'Name can be at most 50 characters',
      nameRequired: 'Name is required',
      noSurveysFound: 'No assignable surveys found (only DRAFT status surveys can be assigned)',
      orSelectDifferent: 'or select a different survey',
      searchButton: 'Search',
      searchPlaceholder: 'Search surveys by name...',
      surveyNameLabel: 'Survey name *',
      title: 'Step 1: Self-Assessment Survey',
      validationErrorsTitle: 'Validation errors',
      validationErrorsToast: 'Validation errors found. Check details below.',
    },
    deleteDialog: {
      cancelButton: 'Cancel',
      deleteButton: 'Delete',
      deleteError: 'Failed to delete certification',
      deleteSuccess: 'Certification deleted successfully',
      deletingButton: 'Deleting...',
      messageEnd: '? This action cannot be undone. The linked survey will not be deleted.',
      messageStart: 'Are you sure you want to delete',
      title: 'Delete Certification',
    },
    detail: {
      backButton: 'Certifications',
      detachError: 'Failed to detach survey',
      detachSuccess: 'Survey detached',
      editButton: 'Edit',
      flowTitle: 'Certification Flow — 4 Steps',
      label: 'Certification',
      loading: 'Loading certification...',
      metaCreated: 'Created',
      metaDeadline: 'Deadline',
      metaUpdated: 'Updated',
      notFound: 'Certification not found',
      participants: {
        addedAt: 'Added',
        attempts_few: '{{count}} attempts',
        attempts_many: '{{count}} attempts',
        attempts_one: '{{count}} attempt',
        attempts_other: '{{count}} attempts',
        bestScore: 'Score {{score}}%',
        drill: {
          comments: 'Commission comments',
          commission: 'Commission',
          commissionRole: {
            CHAIRMAN: 'Chairman',
            HRBP: 'HRBP',
          },
          completedAt: 'Completed',
          daysTitle: 'Exam days',
          noDays: 'No exam days.',
          noTerms: 'No test terms.',
          notPassed: 'Failed',
          passed: 'Passed',
          questions: 'q.',
          score: 'Score',
          termsTitle: 'Test terms',
        },
        email: 'Email',
        error: 'Failed to load participants',
        filters: {
          clear: 'Clear',
          csvHint: 'Separate values with comma or space.',
          employeeSection: 'Employee',
          passed: 'Passed',
          positionCodes: 'Position codes (SAP)',
          regionCodes: 'Region codes',
          scoreMax: 'Max score %',
          scoreMin: 'Min score %',
          status: 'Status',
          surveyAssigned: 'Survey assigned',
          title: 'Filters',
          tri: {
            any: 'Any',
            no: 'No',
            yes: 'Yes',
          },
        },
        filterStagesPlaceholder: 'Filter by stage',
        loading: 'Loading participants...',
        name: 'Name',
        noData: 'No participants found',
        noScore: 'No score',
        openButton: 'Open list',
        rowsPerPage: 'Rows per page',
        searchPlaceholder: 'Search by name or SAP number...',
        stages: 'Stages',
        status: {
          ABSENT: 'Absent',
          CANCELLED: 'Cancelled',
          COMPLETED: 'Completed',
          FAILED: 'Failed',
          IN_PROGRESS: 'In progress',
          NOT_STARTED: 'Not started',
        },
        surveyNotAssigned: 'Not assigned',
        surveyStatus: {
          COMPLETED: 'Completed',
          IN_PROGRESS: 'In progress',
          NOT_STARTED: 'Not started',
        },
        table: {
          exam: 'Practical exam',
          name: 'Participant',
          position: 'Position',
          region: 'Region',
          survey: 'Survey',
          test: 'Knowledge test',
        },
        teaserSubtitle: 'Survey, test and exam results',
        title: 'Participants',
        titleTooltip:
          "Here you'll find all participants of the certification. A participant appears on the list once they are assigned to at least one stage. Adding and removing participants is only possible through the individual stage configuration.",
      },
      stageStatusChange: {
        activateButton: 'Activate',
        activateSuccess: 'Stage activated',
        cancelButton: 'Cancel',
        cancelSuccess: 'Stage cancelled',
        completeButton: 'Complete',
        completeSuccess: 'Stage completed',
        error: 'Failed to change stage status',
        label: 'Change status',
        revertButton: 'Resume',
        revertSuccess: 'Stage resumed',
        testClosureConfirm: {
          cancelAction: 'Cancel',
          confirmAction: 'Yes, close',
          confirmCancel:
            'You are closing the entire test. All terms within this test will be cancelled. Do you want to continue?',
          confirmComplete:
            'You are closing the entire test. All terms within this test will be closed (in-progress terms will be marked as completed, not-yet-started terms will be cancelled). Do you want to continue?',
          titleCancel: 'Cancel test',
          titleComplete: 'Close test',
        },
      },
      statusChange: {
        activateButton: 'Activate',
        activateSuccess: 'Certification activated',
        cancelButton: 'Cancel',
        cancelSuccess: 'Certification cancelled',
        completeButton: 'Complete',
        completeSuccess: 'Certification completed',
        error: 'Failed to change status',
        label: 'Change status',
      },
      statusWarningsDialog: {
        activateButton: 'Activate',
        closeButton: 'Got it',
        subtitle: 'Action completed successfully. Please review the following:',
        title: 'Completed with warnings',
      },
      steps: {
        developmentPlan: {
          comingSoon: 'Coming soon',
          description: 'Step description',
          title: 'Development Plan',
        },
        knowledgeTest: {
          attachButton: 'Attach existing',
          attachDialog: {
            attachButton: 'Attach',
            attachError: 'Failed to attach pool',
            attachingButton: 'Attaching...',
            attachSuccess: 'Pool attached successfully',
            cancelButton: 'Cancel',
            loading: 'Loading pools...',
            noPools: 'No question pools found',
            questionCount: 'questions',
            searchPlaceholder: 'Search pools...',
            title: 'Attach Existing Pool',
          },
          browseButton: 'Browse questions',
          config: {
            backNav: 'back nav',
            notConfigured: 'Test not configured yet',
            pass: 'pass',
            questions: 'questions',
          },
          description:
            "A formal knowledge verification test assessing the participant's theoretical understanding of the certification subject. Configure question pools, schedule test terms, and manage participants to run the examination.",
          detachButton: 'Detach pool',
          detachError: 'Failed to detach pool',
          detachSuccess: 'Pool detached',
          emptyPools: 'No question pools assigned',
          initializeButton: 'Initialize',
          manageParticipantsAndTerms: 'Manage Participants & Terms',
          openConfig: 'Open Configuration',
          poolsTitle: 'Question Pools',
          stageCreatedError: 'Failed to create test stage',
          stageCreatedSuccess: 'Test stage created',
          stageNamePlaceholder: 'Stage name',
          stageNotInitialized: 'Test stage not yet initialized',
          stageParticipants: {
            addButton: 'Add Participants',
            addByEmployee: 'By Employee',
            addByPosition: 'By Position Code',
            addBySap: 'By SAP Number',
            addedHeader: 'Added',
            addError: 'Failed to add participants',
            addPositionButton: 'Add {{count}} position code(s)',
            addPositionCodesHelper:
              'Enter position codes (starting with 2 or 7) separated by commas or new lines',
            addPositionError: 'Failed to add by position',
            addPositionInvalidFormat:
              'Invalid format (must be 8 digits starting with 2 or 7): {{codes}}',
            addPositionPlaceholder: 'e.g. 20000935, 70148208',
            addSapButton: 'Add {{count}} SAP number(s)',
            addSapError: 'Failed to add by SAP number',
            addSapHelper: 'Enter SAP numbers separated by commas or new lines',
            addSapInvalidFormat: 'Invalid format (must be 8 digits): {{numbers}}',
            addSapPlaceholder: 'e.g. 12345678, 87654321',
            addSelectedButton: 'Add {{count}} participant(s)',
            addSuccess: 'Participants added to stage',
            allInStageEmpty: 'All certification participants are already in this stage',
            emailHeader: 'Email',
            filtersClear: 'Clear',
            filterStatus: 'Term status',
            filtersToggle: 'Filters',
            filterTerms: 'Filter by term',
            more: 'more',
            nameHeader: 'Participant',
            noParticipants: 'No participants yet',
            noParticipantsHint: 'Add employees from the certification participant pool above',
            noTerms: 'No terms',
            removeError: 'Failed to remove participant',
            removeSuccess: 'Participant removed from stage',
            removeTooltip: 'Remove from stage',
            searchParticipantsPlaceholder: 'Search certification participants…',
            searchPlaceholder: 'Search by name or email…',
            showing: '{{count}} of {{total}} participants',
            showLess: 'show less',
            status: {
              ASSIGNED: 'Assigned',
              EXPIRED: 'Expired',
              FAILED: 'Failed',
              PASSED: 'Passed',
              STARTED: 'In progress',
            },
            termHistoryHeader: 'Term History',
            title: 'Stage Participants',
          },
          testTerms: {
            cancelButton: 'Cancel',
            cancelledLabel: 'Cancelled',
            completeButton: 'Complete',
            completedLabel: 'Completed',
            createDialog: {
              cancelButton: 'Cancel',
              createButton: 'Create Term',
              createError: 'Failed to create test term',
              createSuccess: 'Test term created',
              creatingButton: 'Creating…',
              endHint: 'Calculated automatically from the test duration configured for this stage',
              endLabel: 'End Date & Time (computed)',
              nameLabel: 'Term Name *',
              nameMaxLength: 'Name can be at most 50 characters',
              namePlaceholder: 'e.g. June 2025 Knowledge Test',
              nameRequired: 'Term name is required',
              startLabel: 'Start Date & Time',
              subtitle: 'Schedule a new test session for this stage',
              title: 'New Term',
            },
            createFirstButton: 'Create First Term',
            editDialog: {
              cancelButton: 'Cancel',
              endLabel: 'End Date & Time',
              hint: 'Start and end times are optional.',
              nameLabel: 'Term Name *',
              namePlaceholder: 'e.g. June 2025 Knowledge Test',
              nameRequired: 'Term name is required',
              saveButton: 'Save Changes',
              savingButton: 'Saving…',
              startLabel: 'Start Date & Time',
              startLockedHelper: 'Start time can only be changed for terms in "New" status.',
              subtitle: 'Update name and schedule for this test term',
              title: 'Edit Test Term',
              updateError: 'Failed to update test term',
              updateSuccess: 'Test term updated',
            },
            extendTimeButton: 'Extend time',
            extendTimeConfirm: 'Extend',
            extendTimeError: 'Failed to extend term time',
            extendTimeHint: 'Maximum allowed extension: {{max}} min',
            extendTimeLabel: 'Minutes',
            extendTimeSuccess: 'Term time extended',
            extendTimeTitle: 'Extend term time',
            hideParticipants: 'Hide participants',
            inProgressLabel: 'In Progress',
            newButton: 'New Term',
            newLabel: 'New',
            noTermsDescription: 'Create a term to schedule and manage test sessions',
            noTermsTitle: 'No test terms yet',
            participants: 'participants',
            participantsDialog: {
              activityReportError: 'Failed to download activity report',
              activityReportTooltip: 'Download activity report (PDF)',
              addButton: 'Add',
              addError: 'Failed to add participants',
              addSelectedButton: 'Add {{count}} participant(s)',
              addSuccess: 'Added {{count}} participant(s) to term',
              allInTermEmpty: 'All stage participants are already in this term',
              closeButton: 'Close',
              emailHeader: 'Email',
              noParticipants: 'No participants yet',
              noParticipantsHint: 'Add participants from the stage pool above',
              participantHeader: 'Participant',
              removeError: 'Failed to remove participant',
              removeSuccess: 'Participant removed from term',
              removeTooltip: 'Remove from term',
              searchByNameEmail: 'Search by name or email…',
              searchPlaceholder: 'Search stage participants…',
              selectLabel: 'Select from stage participants',
              statusAssigned: 'Assigned',
              statusExpired: 'Expired',
              statusFailed: 'Failed',
              statusHeader: 'Status',
              statusPassed: 'Passed',
              statusStarted: 'Started',
              subtitle: 'Term participants',
              title: 'Manage term participants',
              viewResultsTooltip: 'View results',
            },
            resultsDialog: {
              closeButton: 'Close',
              correctAnswerHeader: 'Correct Answer',
              correctLabel: 'Correct',
              executionStatus: {
                COMPLETED_FAILED: 'Failed',
                COMPLETED_PASSED: 'Passed',
                EXPIRED: 'Expired',
                IN_PROGRESS: 'In progress',
                NOT_STARTED: 'Not started',
              },
              filterAll: 'All',
              filterCorrect: 'Correct',
              filterIncorrect: 'Incorrect',
              incorrectLabel: 'Incorrect',
              noAnswerLabel: 'Not answered',
              questionHeader: 'Question',
              sectionHeader: 'Section',
              unansweredLabel: '—',
              yourAnswerHeader: 'Your Answer',
            },
            resultsListDialog: {
              closeButton: 'Close',
              correctHeader: 'Correct',
              noResults: 'No results yet',
              noResultsHint: 'Results will appear once participants complete the test',
              participantHeader: 'Participant',
              scoreHeader: 'Score',
              searchPlaceholder: 'Search by name…',
              statusHeader: 'Status',
              subtitle: '{{count}} participants',
              title: 'Term Results',
              viewDetailTooltip: 'View answers',
            },
            revertButton: 'Resume',
            revertSuccess: 'Term resumed',
            showParticipants: 'Participants ({{count}})',
            startBlockedReason: 'Assign at least one participant to this term before starting',
            startBlockedStageInactiveReason: 'Cannot start term — stage is not active',
            startButton: 'Start',
            startCertificationDraftInfo:
              'The certification is in Draft status. It will be automatically activated upon confirmation so that participants gain access.',
            startExtensionInfo:
              'Time extension is only possible while the test is in progress. Once the time runs out, the term cannot be extended.',
            startInFutureInfo:
              'The exam will be started, but participants will only be able to begin it from {{date}}.',
            startInPastInfo:
              'The scheduled start time ({{date}}) has already passed. The exam will start now.',
            startStageDraftInfo:
              "Stage '{{stageName}}' is in Draft status. It will be automatically activated upon confirmation so that participants gain access to the test.",
            title: 'Test Terms',
            updatedAt: 'Updated',
            updateError: 'Failed to update term status',
            updateSuccess: 'Term status updated',
            viewParticipantsTooltip: 'View participants',
            viewResultsTooltip: 'View results',
          },
          title: 'Knowledge Test',
          uploadButton: 'Upload Pool',
          uploadToPoolButton: 'Upload to pool',
        },
        practicalTest: {
          comingSoon: 'Coming soon',
          config: { notConfigured: 'Exam not configured yet' },
          description: 'Step description',
          examDays: 'Exam days',
          initializeButton: 'Initialize',
          openConfig: 'Open configuration',
          stageCreatedError: 'Failed to create exam stage',
          stageCreatedSuccess: 'Exam stage created',
          stageNamePlaceholder: 'Stage name...',
          stageNotInitialized: 'Practical exam stage has not been initialized.',
          title: 'Practical Test',
        },
        selfAssessment: {
          description:
            'A structured self-evaluation survey completed by the participant before the certification process begins. Helps establish a baseline and identify development gaps.',
          title: 'Self-Assessment',
        },
      },
    },
    examStageConfig: {
      bar: {
        attemptsUnit: 'attempts',
        passPrefix: 'Pass',
        questionsUnit: 'q.',
      },
      cancelButton: 'Cancel',
      configureButton: 'Configure exam',
      confirmDialog: {
        cancel: 'Back to editing',
        confirm: 'Confirm and save',
        title: 'Configuration confirmation',
      },
      editButton: 'Edit configuration',
      fields: {
        maxAttempts: 'Max attempts',
        maxQuestions: 'Max questions',
        minQuestions: 'Min questions',
        noLimit: 'No time limit',
        ofQuestions: 'of questions',
        questionsCount: 'Number of questions',
        questionsShort: 'q.',
        requiredToPass: 'Required questions to pass',
        timeLimitMinutes: 'Time limit (min)',
      },
      notConfigured: 'Exam has not been configured yet',
      saveButton: 'Save configuration',
      validation: {
        maxAttempts: 'Must be between 1 and 10',
        maxQuestions: 'Must be ≥ min questions',
        minQuestions: 'Must be ≥ 1',
        questionsCount: 'Must be ≥ 1',
        requiredToPass: 'Must be between {{min}} and {{max}}',
      },
    },
    examStageDetail: {
      createExamDay: {
        cancelButton: 'Cancel',
        createButton: 'Create',
        fields: {
          chairman: 'Chairman',
          date: 'Date',
          hrbp: 'HRBP',
          location: 'Location',
        },
        title: 'Create exam day',
      },
      examDayDetail: {
        addParticipant: 'Add participant',
        addParticipantDialog: {
          addedEmpty: 'No participants added yet',
          addedTitle: 'Added',
          addTooltip: 'Add to exam day',
          allRegions: 'All regions',
          availableTitle: 'Available',
          clearFilters: 'Clear filters',
          close: 'Close',
          empty: 'All participants already assigned',
          noResults: 'No results for selected filters',
          regionLabel: 'Region',
          searchPlaceholder: 'Search by name or SAP number...',
          title: 'Add participants to exam day',
        },
        cancelDay: 'Cancel',
        cancelExam: 'Cancel exam',
        chairman: 'Chairman',
        columns: {
          actions: 'Actions',
          examStatus: 'Exam status',
          name: 'Name',
          result: 'Result',
        },
        completeDay: 'Complete',
        dayStatus: {
          [ExamDayStatusDto.Cancelled]: 'Cancelled',
          [ExamDayStatusDto.Completed]: 'Completed',
          [ExamDayStatusDto.Draft]: 'New',
          [ExamDayStatusDto.InProgress]: 'In progress',
        },
        examsTitle: 'Exams',
        generateExams: 'Generate exams',
        noExam: 'No exam',
        noParticipants: 'No participants assigned to this exam day',
        participants: 'Participants',
        removeParticipant: 'Remove participant',
        startDay: 'Start day',
      },
      examDays: {
        addButton: 'Add exam day',
        backToList: 'Back to list',
        cancelButton: 'Cancel',
        chairman: 'Chairman',
        completeButton: 'Complete',
        dayStatus: {
          [ExamDayStatusDto.Cancelled]: 'Cancelled',
          [ExamDayStatusDto.Completed]: 'Completed',
          [ExamDayStatusDto.Draft]: 'New',
          [ExamDayStatusDto.InProgress]: 'In progress',
        },
        empty: 'No exam days created yet',
        filters: {
          clear: 'Clear',
          commissionMember: 'Commission',
          dateFrom: 'Date from',
          dateTo: 'Date to',
          noResults: 'No results for selected filters',
          searchPlaceholder: 'Search by name or commission member...',
          toggle: 'Filters',
        },
        participantsCount: 'participants',
        startBlockedStageInactiveReason: 'Cannot start day — stage is not active',
        startButton: 'Start',
        title: 'Exam days',
        updateError: 'Failed to change exam day status',
      },
      examQuestion: {
        answerKeyLabel: 'Answer key',
        chairmanComment: 'Chairman comment',
        commentPlaceholder: 'Add comment...',
        hrbpComment: 'HRBP comment',
        questionLabel: 'Question',
        reportAreaLabel: 'Area',
        reportLabel: 'Report',
        reportShareNotSharedLabel: 'Report not shared with examinee',
        reportShareShareButton: 'Share report with examinee',
        reportShareSharedLabel: 'Report shared with examinee',
        reportShareUnshareButton: 'Unshare report',
        reportTag: 'Report',
        subquestionLabel: 'Subquestion',
        subquestionsTitle: 'Subquestions',
        verdictFail: 'Failed',
        verdictPass: 'Passed',
        verdictRejected: 'Rejected',
      },
      individualExam: {
        cancelButton: 'Cancel exam',
        carriedOver: {
          close: 'Close',
          modalTitle: 'Source exam day',
          previewSourceTooltip: 'Preview source exam day',
          question: 'Question',
          report: 'Report',
          subtitle:
            'Areas marked as "global pass" already passed on another exam day. They are not graded again, but they do count towards this exam\'s result and pass threshold.',
          title: 'Passed in previous exam days',
        },
        chairmanComment: 'Chairman comment',
        changelog: 'Changelog',
        createdAt: 'Created',
        dayNotStarted: 'start exam day first',
        dayNotStartedDialogCancel: 'Cancel',
        dayNotStartedDialogConfirm: 'Start day and exam',
        dayNotStartedDialogMessage:
          'The exam day has not been started yet. To start the exam, the exam day must be started first.',
        dayNotStartedDialogTitle: 'Exam day not started',
        editModeOff: 'Disable comment editing',
        editModeOn: 'Edit comments',
        examStatus: {
          [IndividualExamStatusDto.Cancelled]: 'Cancelled',
          [IndividualExamStatusDto.Draft]: 'Draft',
          [IndividualExamStatusDto.Failed]: 'Failed',
          [IndividualExamStatusDto.Passed]: 'Passed',
          [IndividualExamStatusDto.Started]: 'In progress',
        },
        failed: 'Failed',
        finishButton: 'Finish exam',
        finishedAtLabel: 'Finished',
        generalComment: 'General comments',
        generalCommentPlaceholder: 'Add general comment about the exam...',
        generalCommentVisibilityNotice: 'These comments will be visible to the examinee',
        hrbpComment: 'HRBP comment',
        infoAssignedQuestions: 'Assigned questions',
        infoMinQuestions: 'Min. required',
        infoQuestionsShort: 'q.',
        infoRequiredToPass: 'Required to pass',
        infoTimeLimit: 'Time limit',
        minRequired: 'min {{min}}, graded {{current}}',
        notPassing: 'not passing',
        passed: 'Passed',
        passing: 'passing',
        progress: 'Progress',
        questionsTitle: 'Questions',
        result: 'Result',
        resultFailed: 'EXAM FAILED',
        resultPassed: 'EXAM PASSED',
        stage2AttemptsCount_few: '{{count}} attempts',
        stage2AttemptsCount_many: '{{count}} attempts',
        stage2AttemptsCount_one: '{{count}} attempt',
        stage2AttemptsCount_other: '{{count}} attempts',
        stage2Failed: 'failed',
        stage2NotAvailable: 'Theoretical test not completed',
        stage2NoTerms: 'Participant was not assigned to any term',
        stage2Passed: 'passed',
        stage2Result: 'Stage 2 — Theoretical test',
        stage2Status: {
          ABSENT: 'Absent',
          COMPLETED: 'Passed',
          FAILED: 'Failed',
          IN_PROGRESS: 'In progress',
          NOT_STARTED: 'Not started',
        },
        stage2TermsListTitle: 'Theoretical test — attempts',
        stage2ViewAttemptsTooltip: 'View all attempts',
        stage2ViewTooltip: 'View theoretical test answers',
        startButton: 'Start exam',
        startedAtLabel: 'Started',
        total: 'Total',
      },
      label: 'Practical exam stage',
      loading: 'Loading exam stage...',
      notInitialized:
        'Practical exam stage has not been initialized. Initialize it from the certification detail page.',
      participants: {
        add: 'Add',
        addButton: 'Add participant',
        addByEmployee: 'From certification',
        addByPosition: 'By position',
        addBySap: 'By SAP',
        addedNoneNotFound: 'None of the SAP numbers were found: {{identifiers}}',
        addedNoneTestNotPassed:
          'No one was added — none of the listed employees has passed the test (stage 2).',
        addedSummaryWithSkipped:
          'Added {{added}} participant(s); skipped {{skipped}} without a passed test (stage 2).',
        addedSummaryWithSkippedSap:
          'Added {{added}} participant(s); skipped {{skipped}}: {{identifiers}}',
        addFromCertification: 'Add from certification participants',
        addPositionButton: 'Add {{count}} position(s)',
        addPositionCodesHelper:
          'Enter position codes separated by commas or spaces (format: 2xxxxxxx or 7xxxxxxx)',
        addPositionError: 'Error adding participants by position',
        addPositionInvalidFormat: 'Invalid format: {{codes}}',
        addPositionPlaceholder: 'e.g. 20000001, 70000002',
        addSapButton: 'Add {{count}} SAP number(s)',
        addSapError: 'Error adding participants by SAP',
        addSapHelper: 'Enter SAP numbers separated by commas or spaces (8-digit number)',
        addSapInvalidFormat: 'Invalid format: {{numbers}}',
        addSapPlaceholder: 'e.g. 00012345, 00067890',
        addSelectedButton: 'Add {{count}} participant(s)',
        addSuccess: 'Participants added successfully',
        columns: {
          actions: 'Actions',
          addedAt: 'Added at',
          email: 'Email',
          examStatus: 'Exam status',
          name: 'Name',
        },
        empty: 'No participants added yet',
        filtersClear: 'Clear',
        filtersToggle: 'Filters',
        helpTooltip:
          'Only employees who passed the test (stage 2) within this certification can be added to the practical exam stage (stage 3).',
        noAvailableParticipants: 'All certification participants already added',
        noEligibleParticipants:
          'No eligible participants — none of the employees in this certification has passed the test (stage 2) yet.',
        removeTooltip: 'Remove participant',
        searchPlaceholder: 'Search participants...',
        title: 'Participants',
      },
      practicalAttempts: {
        abandonButton: 'Abandon',
        abandonTooltip: 'Mark as abandoned',
        attemptChip: 'Attempt {{number}} · {{status}}',
        attemptsUsed: 'Attempts used: {{used}}/{{max}}',
        completeButton: 'Complete',
        completeTooltip: 'Mark as completed',
        detail: {
          answerKey: 'Answer key',
          emptyAttempt: 'This attempt contains no questions or reports',
          linkCopied: 'Link copied to clipboard',
          noAttachments: 'No attachments',
          pdfPreviewError: 'Failed to load PDF preview',
          pdfPreviewLoading: 'Loading preview…',
          pdfPreviewPager: 'Page {{page}} / {{total}}',
          questions: 'Questions ({{count}})',
          reports: 'Reports ({{count}})',
          shareButton: 'Share',
          shareError: 'Could not create share link',
          title: 'Attempt {{number}} details',
        },
        limitReached: 'Attempts limit reached',
        maxAttempts: 'Limit: {{count}} attempts',
        noParticipants: 'No participants registered for the practical exam',
        passed: 'Passed',
        startButton: 'Start attempt',
        startError: 'Could not start attempt',
        startSuccess: 'Attempt started',
        status: {
          [PracticalExamAttemptStatusDto.Abandoned]: 'Abandoned',
          [PracticalExamAttemptStatusDto.Completed]: 'Completed',
          [PracticalExamAttemptStatusDto.InProgress]: 'In progress',
        },
        statusUpdateError: 'Could not update status',
        statusUpdateSuccess: 'Status updated',
        title: 'Commission attempts',
      },
      questionPools: {
        attachButton: 'Attach pool',
        browseTooltip: 'Browse questions',
        detachError: 'Failed to detach pool',
        detachSuccess: 'Pool detached',
        detachTooltip: 'Detach pool',
        empty: 'No question pools attached yet. Upload or attach an existing pool.',
        poolCount: 'Pools:',
        questionsCount: 'Questions:',
        title: 'Question Pools',
        uploadButton: 'Upload pool',
        uploadToPoolTooltip: 'Add questions to pool',
      },
      questions: {
        addButton: 'Add question',
        cancelButton: 'Cancel',
        columns: {
          actions: 'Actions',
          answerKey: 'Answer key',
          question: 'Question',
        },
        empty: 'No questions added yet',
        fields: {
          answerKey: 'Answer key',
          questionText: 'Question text',
        },
        generateSample: 'Generate sample (5)',
        removeTooltip: 'Delete question',
        saveButton: 'Add',
        searchPlaceholder: 'Search questions...',
        title: 'Questions',
      },
      tabs: {
        attempts: 'Attempts',
        config: 'Configuration',
        examDays: 'Exam days',
        examDaysLockedReason:
          'Upload questions, configure the stage and assign at least one participant to continue',
        participants: 'Participants',
        questions: 'Questions',
      },
      title: 'Practical Test',
    },
    examStageStatus: {
      [ExamStageStatusDto.Completed]: 'Completed',
      [ExamStageStatusDto.InProgress]: 'In Progress',
      [ExamStageStatusDto.NotInitialized]: 'Not Initialized',
      [ExamStageStatusDto.NotStarted]: 'Not Started',
    },
    filters: {
      allStatuses: 'All statuses',
      searchButton: 'Search',
      searchPlaceholder: 'Search by name...',
      status: 'Status',
    },
    formDialog: {
      cancelButton: 'Cancel',
      clearDeadline: 'Clear deadline',
      createButton: 'Create',
      createError: 'Failed to create certification',
      createSuccess: 'Certification created successfully',
      createTitle: 'Create Certification',
      deadlineHelp: 'Optional completion deadline',
      deadlineLabel: 'Deadline',
      deadlinePastConfirm: 'The selected deadline is in the past. Are you sure you want to set it?',
      deadlinePastWarning: 'Deadline is in the past',
      deadlineValidation: 'Deadline must be today or in the future',
      description: 'Description',
      descriptionMaxLength: 'Description can be up to 200 characters',
      editTitle: 'Edit Certification',
      nameLabel: 'Name *',
      nameMaxLength: 'Name can be up to 50 characters',
      nameRequired: 'Name is required',
      saveButton: 'Save Changes',
      savingButton: 'Saving...',
      status: 'Status',
      updateError: 'Failed to update certification',
      updateSuccess: 'Certification updated successfully',
    },
    itemRow: {
      createdAt: 'Created',
      deleteDisabledTooltip: 'Can only delete DRAFT certifications',
      deleteTooltip: 'Delete',
      openTooltip: 'Open',
    },
    loadError: 'Failed to load certifications',
    loading: 'Loading certifications...',
    newButton: 'New Certification',
    practicalExam: {
      attachDialog: {
        attachButton: 'Attach',
        attachError: 'Failed to attach pool',
        attachingButton: 'Attaching...',
        attachSuccess: 'Pool attached',
        cancelButton: 'Cancel',
        noPools: 'No practical exam pools found',
        questionCount: 'questions',
        searchButton: 'Search',
        searchPlaceholder: 'Search pools...',
        title: 'Attach practical exam pool',
      },
      poolCard: {
        detachButton: 'Detach pool',
        questionsLabel: 'questions',
        showQuestions: 'Show {{count}} questions',
        uploadToPoolButton: 'Add questions to pool',
      },
      questionsBrowser: {
        addAttachmentButton: 'Add PDF',
        answerKeyLabel: 'Answer key',
        areaAll: 'All areas',
        attachmentDeleteError: 'Failed to delete attachment',
        attachmentDeleteSuccess: 'Attachment deleted',
        attachmentsLabel: 'Attachments',
        deleteAttachment: 'Delete attachment',
        downloadAttachment: 'Download',
        globalPassLabel: 'Globally passed',
        globalPassTooltip: 'If enabled, this question/report will not reappear in retake attempts',
        noAttachments: 'No attachments yet',
        noQuestions: 'No simple questions',
        noReports: 'No reports',
        previewAttachment: 'Preview',
        previewCloseButton: 'Close',
        questionsSection: 'Simple questions',
        reportChipLabel: 'REPORT',
        reportsSection: 'Reports',
        searchPlaceholder: 'Search by content or answer key...',
        subquestionsLabel: 'Subquestions',
      },
      reportAttachmentDialog: {
        cancelButton: 'Cancel',
        chooseFileButton: 'Choose PDF',
        dragDropText: 'Drag & drop or click to select a PDF file',
        errorToast: 'Upload failed',
        fileLabel: 'PDF file *',
        fileRequired: 'File is required',
        fileTooLarge: 'File is too large (max 10 MB)',
        hint: 'PDF only, max 10 MB.',
        invalidFileType: 'Only PDF files are allowed',
        successToast: 'Attachment uploaded',
        title: 'Add attachment to report "{{area}}"',
        uploadButton: 'Upload',
        uploadingButton: 'Uploading...',
      },
      uploadPoolDialog: {
        appendTitle: 'Upload to practical exam stage',
        cancelButton: 'Cancel',
        chooseFileButton: 'Choose file',
        dragDropText: 'Drag & drop or click to select .xlsx file',
        errorToast: 'Upload failed',
        fileLabel: 'File (XLSX) *',
        fileRequired: 'File is required',
        formatColumns:
          'One sheet per area (OiW/Pieczywo/Lada): Section | Subcategory | Scored (TAK/NIE). "Raporty" sheet: Report name | Section | Subcategory | Scored.',
        formatTitle: 'Expected format (multi-sheet)',
        formatTypes:
          '"_Globalne zaliczenie" sheet: Area | Global pass. Answer keys and PDF files are filled in the app after upload.',
        nameHelp: 'Optional pool name (defaults to "Pula pytań egzaminu praktycznego")',
        nameLabel: 'Pool name',
        successToast: 'Pool uploaded successfully',
        title: 'Upload practical exam question pool',
        uploadButton: 'Upload',
        uploadingButton: 'Uploading...',
        validationErrorsTitle: 'Validation errors',
      },
      uploadToExistingPoolDialog: {
        cancelButton: 'Cancel',
        chooseFileButton: 'Choose file',
        dragDropText: 'Drag & drop or click to select .xlsx file',
        errorToast: 'Upload failed',
        fileLabel: 'File (XLSX) *',
        fileRequired: 'File is required',
        successToast: 'Questions added successfully',
        title: 'Add practical exam questions to "{{poolName}}"',
        uploadButton: 'Upload',
        uploadingButton: 'Uploading...',
        validationErrorsTitle: 'Validation errors',
      },
    },
    questionPools: {
      filters: {
        allTypes: 'All types',
        search: 'Search',
        searchPlaceholder: 'Search by name...',
      },
      table: {
        actions: 'Actions',
        browseButton: 'Browse questions',
        createdAt: 'Created',
        name: 'Name',
        noData: 'No question pools found',
        questionCount: 'Questions',
        rowsPerPage: 'Rows per page',
        type: 'Type',
        uploadButton: 'Upload Pool',
      },
      title: 'Question Pools',
    },
    questionsBrowser: {
      explanationLabel: 'Explanation',
      noResults: 'No questions found',
      questionCount: 'questions',
      rankLabel: 'Rank',
      searchPlaceholder: 'Search questions...',
      sectionPlaceholder: 'Filter by section',
      singleChoiceLabel: 'Single choice',
      tabPool: 'This pool',
      tabStage: 'All pools',
      title: 'Browse Questions',
      typeAll: 'All types',
      typeRank: 'Rank',
      typeSingleChoice: 'Single choice',
    },
    status: {
      [CertificationStatusDto.Active]: 'Active',
      [CertificationStatusDto.Cancelled]: 'Cancelled',
      [CertificationStatusDto.Completed]: 'Completed',
      [CertificationStatusDto.Draft]: 'Draft',
    },
    stepCard: {
      configured: 'Configured',
      instructionsTooltip: 'Show admin instructions',
      notConfigured: 'Not configured',
      stepLabel: 'Step',
    },
    stepLabels: {
      comingSoon: 'coming soon',
      devPlan: 'Dev Plan',
      knowledgeTest: 'Knowledge Test',
      notConfigured: 'Not configured',
      participants: '{{count}} participants',
      practicalTest: 'Practical Test',
      selfAssessment: 'Self-Assessment',
    },
    summary: {
      active: 'Active',
      completed: 'Completed',
      draft: 'Draft',
      total: 'Total',
    },
    surveyStep: {
      activationDialog: {
        cancel: 'Cancel',
        confirm: 'Activate & start',
        description:
          'For participants to receive survey notifications, the following statuses must be active. Activate them now and start the survey?',
        error: 'Failed to activate statuses',
        itemCertification: 'Certification — will be activated',
        itemStage: 'Stage 1 (Self-Assessment) — will be activated',
        success: 'Statuses activated and survey started',
        title: 'Activation required',
      },
      assignExisting: 'Assign existing',
      changeButton: 'Change',
      changeSurveyTooltip: 'Change survey',
      createNew: 'Create new',
      deadlineLabel: 'Deadline',
      deadlinePastTooltip: 'Deadline has passed — consider changing status to Completed.',
      detachButton: 'Detach',
      detachSurveyTooltip: 'Detach survey',
      noParticipants: 'No participants',
      noSurveyDescription: 'Assign an existing survey or create a new one for this certification.',
      noSurveyTitle: 'No survey assigned',
      participants: 'participants',
      startDisabledTooltip: 'Add participants to start the survey',
      status: {
        ACTIVE: 'Active',
        CANCELLED: 'Cancelled',
        COMPLETED: 'Completed',
        DRAFT: 'Draft',
      },
      statusAction: {
        cancel: 'Cancel',
        complete: 'Complete',
        start: 'Start',
      },
    },
    table: {
      actions: 'Actions',
      createdBy: 'Created by',
      deadline: 'Deadline',
      name: 'Name',
      noData: 'No certifications found',
      status: 'Status',
      steps: 'Steps',
    },
    testStageConfig: {
      activateBlockedReason: 'Create at least one test term to activate this stage',
      bar: {
        passPrefix: 'Pass',
        questionsUnit: 'q.',
        resultVisibilityWindow: 'Questions visible {{minutes}} min after end',
      },
      cancelButton: 'Cancel',
      configureButton: 'Configure test',
      editButton: 'Edit configuration',
      fields: {
        allowBackNavigation: 'Back navigation',
        backNavEnabled: 'Back nav enabled',
        noLimit: 'No limit',
        numberOfQuestions: 'Questions',
        passingThreshold: 'Pass threshold (%)',
        resultVisibility: 'Result visibility',
        resultVisibilityWindowMinutes: 'Questions visibility window (min)',
        resultVisibilityWindowMinutesHint: 'After this only the score remains',
        timeExtensionHint: 'Max. {{max}} min',
        timeExtensionMinutes: 'Time extension (min)',
        timeLimitMinutes: 'Time limit (min)',
      },
      label: 'Test Configuration',
      notConfigured: 'Test not configured yet',
      pools: {
        attachButton: 'Attach existing',
        attachError: 'Failed to detach pool',
        browseButton: 'Browse questions',
        detachBlockedByActiveTerm:
          'Cannot detach pool — the stage has an active term (NEW or IN_PROGRESS). Cancel or finish all active terms first.',
        detachButton: 'Detach',
        detachError: 'Failed to detach pool',
        none: 'No question pools attached',
        poolCount: 'Pools:',
        poolQuestionCount: 'Questions:',
        questionsLabel: 'questions',
        title: 'Question Pools',
        uploadButton: 'Upload new',
        uploadToPoolButton: 'Upload more questions',
      },
      resultVisibilityOptions: {
        none: 'None (results not shared)',
        resultOnly: 'Result only (pass/fail)',
        resultWithQuestions: 'Result + questions with error marking',
        resultWithScore: 'Result + percentage score',
      },
      saveButton: 'Save config',
      saveError: 'Failed to save configuration',
      saveSuccess: 'Configuration saved',
      sections: {
        available: 'Available: {{count}} questions',
        exceedsAvailable: 'Max {{count}} available',
        none: 'No section distribution configured',
        title: 'Section distribution',
        total: 'Total: {{total}} questions',
        totalLabel: 'Total questions',
      },
    },
    testStageDetail: {
      backButton: 'Back to Certification',
      label: 'Knowledge Test Stage',
      loading: 'Loading test stage...',
      notFound: 'Test stage not found',
      notInitialized:
        'Test stage not initialized. Initialize it from the certification detail first.',
      subtitle: 'Stage Management — Participants & Test Terms',
      tabs: {
        config: 'Test Configuration',
        configLockedReason: 'Upload a question pool first to unlock the configuration',
        participants: 'Stage Participants',
        participantsLockedReason: 'Save the test configuration first',
        pools: 'Question Pools',
        terms: 'Test Terms',
        termsLockedReason:
          'Configure the stage and assign at least one participant to the stage to continue',
      },
      title: 'Knowledge Test',
    },
    title: 'Certifications',
    uploadPoolDialog: {
      appendTitle: 'Upload to Existing Stage',
      cancelButton: 'Cancel',
      chooseFileButton: 'Choose file',
      dragDropText: 'Drag & drop or click to select .xlsx file',
      errorToast: 'Upload failed',
      fileLabel: 'File (XLSX) *',
      fileRequired: 'File is required',
      nameHelp: 'Optional name (defaults to sheet name)',
      nameLabel: 'Pool name',
      successToast: 'Pool uploaded successfully',
      title: 'Upload Question Pool',
      uploadButton: 'Upload',
      uploadingButton: 'Uploading...',
      validationErrorsTitle: 'Validation errors',
    },
    uploadToExistingPoolDialog: {
      cancelButton: 'Cancel',
      chooseFileButton: 'Choose file',
      dragDropText: 'Drag & drop or click to select .xlsx file',
      errorToast: 'Upload failed',
      fileLabel: 'File (XLSX) *',
      fileRequired: 'File is required',
      successToast: 'Questions added successfully',
      title: 'Add questions to "{{poolName}}"',
      uploadButton: 'Upload',
      uploadingButton: 'Uploading...',
      validationErrorsTitle: 'Validation errors',
    },
  },
  changeHistory: {
    filters: {
      action: 'Action',
      actions: {
        activate: 'Activate',
        assign: 'Assign',
        create: 'Create',
        deactivate: 'Deactivate',
        delete: 'Delete',
        toggleOverride: 'Toggle Override',
        unassign: 'Unassign',
        update: 'Update',
      },
      all: 'All',
      changedAfter: 'Changed After',
      changedBefore: 'Changed Before',
      changedByUserEmail: 'Changed By',
      changeType: 'Change Type',
      changeTypes: {
        permissionEdit: 'Permission Edit',
        roleEdit: 'Role Edit',
        rolePermissionAssignment: 'Role Permission Assignment',
        userPermissionChange: 'User Permission Change',
        userRoleChange: 'User Role Change',
      },
      clearFilters: 'Clear Filters',
      targetUserEmail: 'Target User',
    },
    table: {
      actions: {
        ACTIVATE: 'Activate',
        ASSIGN: 'Assign',
        CREATE: 'Create',
        DEACTIVATE: 'Deactivate',
        DELETE: 'Delete',
        TOGGLE_OVERRIDE: 'Toggle Override',
        UNASSIGN: 'Unassign',
        UPDATE: 'Update',
      },
      changeTypes: {
        PERMISSION_EDIT: 'Permission Edit',
        ROLE_EDIT: 'Role Edit',
        ROLE_PERMISSION_ASSIGNMENT: 'Role Permission Assignment',
        USER_PERMISSION_CHANGE: 'User Permission Change',
        USER_ROLE_CHANGE: 'User Role Change',
      },
      error: 'Error loading data',
      fieldName: 'Field',
      headers: {
        action: 'Action',
        changedAt: 'Changed At',
        changedBy: 'Changed By',
        changeType: 'Change Type',
        description: 'Description',
        id: 'ID',
        permission: 'Permission',
        role: 'Role',
        targetUser: 'Target User',
      },
      loading: 'Loading change history...',
      newValue: 'New Value',
      noData: 'No data to display',
      oldValue: 'Old Value',
      rowsPerPage: 'Rows per page',
    },
  },
  confirmPermissionAction: {
    actions: {
      activatePermission: {
        description:
          'Activating the permission will make it available in the system and assignable to roles and users.',
        title: 'Are you sure you want to activate this permission?',
        warning: '',
      },
      addIndividualPermission: {
        description:
          'Adding an individual permission will grant the user this permission regardless of assigned roles.',
        title: 'Are you sure you want to add this individual permission?',
        warning:
          'Individual permissions are granted directly to the user and are not managed through roles.',
      },
      addRoleToUser: {
        description: 'Adding the role will grant the user all permissions assigned to this role.',
        title: 'Are you sure you want to add this role?',
        warning: '',
      },
      assignPermissionToRole: {
        description:
          'Assigning a permission to the role will grant it to all users with this role.',
        title: 'Are you sure you want to assign this permission to the role?',
        warning: 'This change will affect all users assigned to this role.',
      },
      deactivatePermission: {
        description:
          'Deactivating the permission will make it unavailable in the system and it will no longer be assignable.',
        title: 'Are you sure you want to deactivate this permission?',
        warning:
          'The permission will remain assigned to existing roles and users but will be inactive.',
      },
      deactivateRolePermission: {
        description:
          'Deactivating the permission from the role will remove it for this user from this role, but they may still have it from other sources.',
        title: 'Are you sure you want to deactivate this permission?',
        warning:
          'This does not remove the permission from the role, it only disables it for this specific user.',
      },
      removeIndividualPermission: {
        description:
          'Removing the individual permission will revoke it from the user (unless they have it from an assigned role).',
        title: 'Are you sure you want to remove this individual permission?',
        warning: '',
      },
      removePermissionFromRole: {
        description:
          'Removing a permission from the role will revoke it from all users with this role.',
        title: 'Are you sure you want to remove this permission from the role?',
        warning: 'This change will affect all users assigned to this role.',
      },
      removeRoleFromUser: {
        description:
          'Removing the role will revoke all permissions assigned to this role from the user.',
        title: 'Are you sure you want to remove this role?',
        warning: 'System roles cannot be removed, they can only be deactivated.',
      },
      toggleRole: {
        description:
          'Changing the role status will enable/disable all permissions from this role for this user.',
        title: 'Are you sure you want to change this role status?',
        warning: 'Applies to system roles only.',
      },
    },
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  dictionaries: {
    editDialog: {
      active: 'Active',
      cancel: 'Cancel',
      englishName: 'English Name',
      polishName: 'Polish Name',
      save: 'Save',
      saving: 'Saving...',
      title: 'Edit Dictionary Entry',
    },
    filters: {
      active: 'Active',
      allStatuses: 'All statuses',
      allTypes: 'All Types',
      inactive: 'Inactive',
      name: 'Name',
      searchByName: 'Search by name',
      status: 'Status',
      type: 'Type',
    },
    table: {
      actions: 'Actions',
      code: 'Code',
      edit: 'Edit',
      englishName: 'English Name',
      noData: 'No data matching the selected filters is available',
      noFilters: 'Please select a dictionary type first to view data',
      polishName: 'Polish Name',
      rowsPerPage: 'Rows per page',
      status: {
        false: 'Inactive',
        true: 'Active',
      },
      statusHeader: 'Status',
      type: 'Type',
    },
    title: 'Dictionaries',
  },
  employeesList: {
    buttons: {
      export: 'Export to Excel',
    },
    content: {
      table: {
        active: 'Active',
        email: 'Email',
        externalEmployeeId: 'SAP ID',
        firstName: 'First Name',
        inactive: 'Inactive',
        lastName: 'Last Name',
      },
    },
    dialog: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      message: 'Are you sure you want to change the active status of this employee?',
      title: 'Confirm Status Change',
    },
    form: {
      externalEmployeeId: 'SAP ID',
      firstName: 'First Name',
      lastName: 'Last Name',
    },
  },
  groups: {
    certification: 'Certification',
    content: 'Content',
    management: 'Management',
    tools: 'Tools',
  },
  impersonation: {
    blockedDisabled: 'This account is inactive, so you cannot switch to it.',
    blockedNoRole: 'This person has no role assigned, so you cannot switch to them.',
    blockedPrivileged:
      'This person holds administrative permissions (roles management or session switching), so you cannot switch to them.',
    noEmployeeRecordChip: 'no employee record',
    noRoleChip: 'no role',
    privilegedChip: 'administrative permissions',
  },
  news: {
    actions: {
      archive: 'Archive',
      backToDraft: 'Move to draft',
      cancel: 'Cancel',
      delete: 'Remove',
      edit: 'Edit',
      error: 'Could not update news status. Try again.',
      preview: 'Preview',
      publish: 'Publish',
    },
    categories: {
      [NewsCategoryDto.Business]: 'Development',
      [NewsCategoryDto.System]: 'jAIn updates',
      [NewsCategoryDto.Tutorials]: 'Tutorials',
    },
    confirmations: {
      archive: {
        confirm: 'Archive',
        message: 'This article will be archived and removed from the landing page news feed.',
        title: 'Archive news',
      },
      delete: {
        confirm: 'Remove',
        message:
          'Are you sure you want to permanently remove this article? This action cannot be undone.',
        title: 'Remove news',
      },
      draft: {
        confirm: 'Move to draft',
        message: 'This article will stop being visible in published news lists.',
        title: 'Move news to draft',
      },
      publish: {
        confirm: 'Publish',
        message: 'This article will become visible in the landing page news feed.',
        title: 'Publish news',
      },
    },
    editor: {
      cancel: 'Cancel',
      categoryLabel: 'Category',
      categoryRequired: 'Category is required',
      changeImage: 'Change image',
      chooseImage: 'Choose image',
      contentHelp: '',
      contentLabel: 'Content',
      createError: 'Could not create news item.',
      createTitle: 'Create new publication',
      editTitle: 'Edit publication',
      imageClear: 'Clear',
      imageDropActive: 'Drop the image here',
      imageDropReplace: 'Drop or click to replace image',
      imageDropSubtitle: 'Accepted formats: JPEG, PNG, WebP',
      imageDropTitle: 'Drag and drop an image or click to choose',
      imageHelp:
        'Optional. JPEG, PNG or WebP, up to 10 MB. The image is inserted into article content after saving.',
      imageLabel: 'In-text image',
      imageSelected: 'Selected images:',
      imageSizeError: 'Image can be up to 10 MB.',
      imageTypeError: 'Use JPEG, PNG or WebP image.',
      loading: 'Loading article...',
      publishNow: 'Publish now',
      save: 'Save',
      saveChanges: 'Save changes',
      saveDraft: 'Save as draft',
      saving: 'Saving...',
      subtitle: 'Prepare the article content and publish it when ready.',
      titleLabel: 'Title',
      titleMaxLength: 'Title can have up to 180 characters',
      titlePlaceholder: 'e.g. New reporting rules...',
      titleRequired: 'Title is required',
      toolbar: {
        bold: 'Bold',
        image: 'Insert image',
        italic: 'Italic',
        link: 'Paste link URL',
        linkDialog: {
          apply: 'Apply link',
          cancel: 'Cancel',
          title: 'Insert link',
        },
        orderedList: 'Numbered list',
        underline: 'Underline',
        unorderedList: 'Bulleted list',
        video: 'Insert video (supported formats: MP4, WebM)',
      },
      untitledDraft: 'Untitled draft',
      updateError: 'Could not update news item.',
      videoProcessing: 'Video is being processed, it will appear after saving.',
      videoTypeError: 'Use MP4 or WebM video. QuickTime/MOV is not supported in Firefox.',
    },
    empty: {
      title: 'No news found',
    },
    filters: {
      allCategories: 'All categories',
      allStatuses: 'All statuses',
      category: 'Category',
      searchPlaceholder: 'Search news by title...',
      status: 'Status',
    },
    newButton: 'New article',
    preview: {
      close: 'Close',
      emptyContent: 'No content has been added yet.',
      subtitle: 'See how the news is seen by employees on the landing page.',
      title: 'News preview',
      videoError: 'This video cannot be played. The file may be damaged or encoded incorrectly.',
    },
    statuses: {
      [NewsStatusDto.Archived]: 'Archived',
      [NewsStatusDto.Draft]: 'Draft',
      [NewsStatusDto.Published]: 'Published',
    },
    subtitle: 'Create, edit, publish and archive articles.',
    table: {
      actions: 'Actions',
      category: 'Category',
      createdAt: 'Created',
      error: 'Error loading news',
      loading: 'Loading news...',
      noData: 'No news matches the current filters.',
      noImage: 'No image',
      publishedAt: 'Published',
      rowsPerPage: 'Rows per page',
      status: 'Status',
      title: 'Title',
      updatedAt: 'Updated',
    },
    title: 'News management',
  },
  noPermissions: 'You do not have permissions to access any section of the admin panel.',
  permissionDetails: {
    active: 'Active',
    category: 'Category',
    code: 'Code',
    description: 'Description',
    inactive: 'Inactive',
    name: 'Name',
    noDescription: 'No description',
    status: 'Permission status',
    title: 'Permission details',
  },
  permissionsEmployees: {
    backToList: 'Back to list',
    columns: {
      department: 'Department',
      email: 'Email',
      employee: 'Employee',
      sap: 'SAP',
      status: 'Status',
    },
    description: 'Search for an employee to manage their roles and permissions.',
    detail: {
      activate: 'Activate',
      allWithCount: 'All ({{count}})',
      assignedPermissions: 'Assigned permissions',
      assignedRoles: 'Assigned roles ({{count}})',
      availablePermissions: 'Available permissions',
      availableRoles: 'Available roles ({{count}})',
      categoryNone: 'None',
      categoryUncategorized: 'Uncategorized',
      deactivate: 'Deactivate',
      fromRole: 'from role: {{role}}',
      hrbpTitle: 'Unit / position permissions',
      individualPermissions: 'Individual permissions',
      noAssignedPermissions: 'No assigned permissions',
      noAssignedRoles: 'No assigned roles',
      noAvailablePermissions: 'No available permissions',
      noAvailableRoles: 'No available roles',
      noPermissionsMatch: 'No permissions match the criteria.',
      noResults: 'No results',
      noRolePermissions: 'No permissions from roles.',
      permissionCount: 'Permission count: {{count}}',
      permissionsTitle: 'Permissions',
      roleDisableSuffix: 'disable',
      roleEnableSuffix: 'enable',
      rolePermissions: 'Permissions from roles',
      rolesTitle: 'Employee roles',
      searchByNameOrCode: 'Search by name or code',
      statusActive: 'Active',
      statusDisabled: 'Disabled',
      systemBadge: 'SYSTEM',
      systemRolesInfoBody:
        'System roles are assigned automatically and cannot be removed. They can only be enabled/disabled for a specific employee.',
      systemRolesInfoTitle: 'System roles',
      toast: {
        bulkPartial: 'Updated {{success}} of {{total}} permissions. Check the console for details.',
        cannotRemoveSystemRole: 'System role cannot be removed. You can only deactivate it.',
        individualsAdded: 'Individual permissions added',
        individualsAddError: 'Failed to add individual permissions',
        individualsRemoved: 'Individual permissions removed',
        individualsRemoveError: 'Failed to remove individual permissions',
        noRolesSelected: 'No roles selected for update',
        permissionActivated: 'Permission "{{name}}" has been activated',
        permissionActivatedForRoles:
          'Permission "{{name}}" has been activated for roles: {{roles}}',
        permissionDeactivated: 'Permission "{{name}}" has been deactivated',
        permissionDeactivatedForRoles:
          'Permission "{{name}}" has been deactivated for roles: {{roles}}',
        permissionUpdateError: 'Failed to update permission',
        roleAdded: 'Role "{{name}}" has been added',
        roleAddError: 'Failed to add role to user',
        roleDisabled: 'Role "{{name}}" has been disabled',
        roleEnabled: 'Role "{{name}}" has been enabled',
        roleNotFoundForPermission: 'No role found for this permission',
        rolePermissionUpdateError: 'Failed to update permission from roles',
        roleRemoved: 'Role has been removed',
        roleRemoveError: 'Failed to remove role from user',
        roleUpdateError: 'Failed to update user role',
      },
    },
    emptyResultsDescription: 'No employees found matching the given criteria.',
    emptyResultsTitle: 'No results',
    loading: 'Loading employees...',
    onlyModified: 'Only modified',
    rowsPerPage: 'Per page:',
    searchPlaceholder: 'Search by SAP, first name, last name, email...',
    startDescription: 'Type a search term or enable the filter to display employees.',
    startTitle: 'Start searching',
    statusModified: 'Modified',
    title: 'Employees — Roles and Permissions',
  },
  permissionsTable: {
    active: 'Active',
    allCategories: 'All categories',
    columnActions: 'Actions',
    columnCategory: 'Category',
    columnCode: 'Code',
    columnDescription: 'Description',
    columnName: 'Name',
    columnStatus: 'Status',
    count: '{{filtered}} of {{total}} permissions',
    deleteCentralInfo: 'Deleting permission "{{code}}" is managed centrally.',
    editCentralInfo: 'Editing permission "{{code}}" is available only in the system panel.',
    emptyDescription: 'No permissions have been defined in the system yet.',
    emptyFilteredDescription: 'No permissions match the given criteria. Try changing the filters.',
    emptyFilteredTitle: 'No results',
    emptyTitle: 'No permissions',
    inactive: 'Inactive',
    loading: 'Loading permissions...',
    searchPlaceholder: 'Code, name or description...',
    toggleError: 'Failed to update the permission',
    toggleSuccess: 'Permission status updated',
  },
  professionalActivityDefinitions: {
    documents: {
      aiContext: 'AI context',
      aiContextTooltip:
        'When on, the document feeds the AI assistant for assigned employees. Off = download only.',
      deleteDialog: {
        cancel: 'Cancel',
        confirm: 'Delete',
        message: 'This file will be permanently deleted. This action cannot be undone.',
        title: 'Delete document',
      },
      dropzoneHintPrefix: 'or drag and drop a file here.',
      dropzoneLabel: 'Click to upload a file',
      dropzoneMaxSize: 'Max size: 20 MB',
      embeddingStatus: {
        available: '✓ Available in AI',
        failed: 'Processing failed',
        noContent: 'No content',
        notEmbedded: 'Not processed',
        processing: 'Processing...',
      },
      empty: 'No documents attached yet',
      loading: 'Loading documents...',
      reembed: 'Re-process',
      title: 'Documents',
    },
    editDialog: {
      cancel: 'Cancel',
      description: 'Description',
      developmentProgram: 'Development program',
      editYear: 'Edition year',
      name: 'Name',
      save: 'Save',
      saving: 'Saving...',
      status: 'Status',
      statusValues: {
        COMPLETED: 'Completed',
        IN_PROGRESS: 'In progress',
        PLANNED: 'Planned',
      },
      title: 'Edit professional activity definition',
    },
    searchPlaceholder: 'Search by name',
    table: {
      description: 'Description',
      developmentProgram: 'Development program',
      editYear: 'Edition year',
      name: 'Name',
      noData: 'No professional activity definitions found',
      rowsPerPage: 'Rows per page',
      status: 'Status',
      statusValues: {
        COMPLETED: 'Completed',
        IN_PROGRESS: 'In progress',
        PLANNED: 'Planned',
      },
      updatedAt: 'Updated',
    },
    title: 'Development Activities',
  },
  ragDocuments: {
    form: {
      fields: {
        categories: {
          label: 'Categories',
          placeholder: 'Select categories',
        },
        description: {
          label: 'Description',
        },
        file: {
          accepted: 'Accepted formats: PDF, DOCX (max 10MB)',
          dropzoneLabel: 'Drag and drop a file here, or click to select',
          remove: 'Remove',
        },
        tags: {
          label: 'Tags',
          placeholder: 'Type a tag and press Enter',
        },
        title: {
          label: 'Title',
        },
      },
      status: {
        awaitingValidationResolution: 'Awaiting validation resolution',
        close: 'Close',
        error: 'Upload failed',
        finished: 'Upload completed',
        inProgress: 'Processing',
        notStarted: 'Initializing upload',
        processing: 'Processing document...',
        readingDocument: 'Reading document',
        validationFailed: 'Validation failed',
      },
      submitButton: 'Upload document',
      submitButtonLoading: 'Uploading...',
      title: 'Upload new document',
      toasts: {
        initError: 'Failed to initiate document upload',
        sseError: 'Lost connection to the upload progress server',
        uploadError: 'Failed to upload the document',
        uploadSuccess: 'Document has been uploaded.',
      },
    },
  },
  roleAssignments: {
    allWithCount: 'All ({{count}})',
    assignAriaLabel: 'Assign selected permissions',
    assignedTitle: 'Assigned permissions – {{role}}',
    assignError: 'Failed to add permissions to the role',
    assignSuccess: 'Permissions added to the role',
    availableTitle: 'Available permissions',
    categoryWithCount: '{{category}} ({{count}})',
    confirmDetails: 'Permissions: {{count}}\nRole: {{role}}',
    count: '{{filtered}} of {{total}} permissions',
    emptyAssigned: 'No permissions assigned to this role.',
    emptyAvailable: 'No permissions available to assign.',
    emptyFiltered: 'No permissions match the filter criteria.',
    noRoles: 'No roles available.',
    removeAriaLabel: 'Remove selected permissions',
    removeError: 'Failed to remove permissions from the role',
    removeSuccess: 'Permissions removed from the role',
    rolePlaceholder: '---',
    rolesTitle: 'Roles',
    searchPlaceholder: 'Search by name or code',
    selectAll: 'Select all',
    selectedCount: 'Selected: {{count}}',
  },
  roleForm: {
    cancel: 'Cancel',
    colorHint: 'Color used in cards and charts.',
    colorLabel: 'Color',
    createTitle: 'New role',
    descriptionLabel: 'Role description',
    editTitle: 'Edit role',
    nameLabel: 'Role name',
    save: 'Save',
  },
  roles: {
    badgePermissions: '{{count}} permissions',
    badgePermissionsSystem: '{{count}} permissions • system role',
    count: '{{count}} roles',
    emptyDescription: 'No roles found in the system.',
    emptySearchDescription:
      'No roles found matching "{{search}}". Try changing your search criteria.',
    emptySearchTitle: 'No search results',
    emptyTitle: 'No roles',
    loading: 'Loading roles...',
    searchPlaceholder: 'Search roles',
    updateError: 'Failed to update the role',
    updateSuccess: 'Role updated',
  },
  sections: {
    accounts: {
      description: 'Search, verify and manage system account access.',
    },
    data: {
      historyDescription: 'Review import status, validation errors and recent upload activity.',
      historyTitle: 'Upload history',
      uploadDescription: 'Upload employee, organizational and system data files from one panel.',
      uploadTitle: 'Upload data',
    },
    developmentCycles: {
      activeChip: 'Active',
      applyToAllChip: 'Applies to everyone',
      cancelCampaign: {
        cancel: 'Cancel',
        confirm: 'End campaign',
        description:
          'End the campaign “{{name}}”? All of its development plans (completed ones included) move to history and their open tasks are cancelled.',
        notice:
          'A separate, deliberate action — not a plain deactivation. A historical plan can be restored once the employee is covered by this campaign again.',
        title: 'End campaign',
      },
      delete: {
        cancel: 'Cancel',
        confirm: 'Delete campaign',
        description: 'Delete the campaign "{{name}}"? This action cannot be undone.',
        title: 'Delete campaign',
      },
      description:
        'Development-cycle campaigns: window, task start date and covered employees. Several campaigns can be active, but an employee belongs to exactly one.',
      fields: {
        covered: 'Covered employee SAP numbers',
        coveredAll: 'Everyone not covered by another campaign. This campaign creates no tasks.',
        coveredEmpty: 'Empty list — the campaign covers nobody, so no tasks will be created.',
        name: 'Name',
        noName: '(no name)',
        tasksStartDate: 'Tasks created from',
        window: 'Cycle window',
      },
      form: {
        active: 'Campaign active',
        activeHint:
          'Several campaigns can be active in parallel. A SAP number may belong to only one of them.',
        applyToAll: 'Apply to everyone',
        applyToAllHint:
          'The campaign covers everyone no other campaign covers. Only one such campaign can be active.',
        applyToAllNotice:
          'A catch-all campaign creates no tasks — it only opens self-service plan creation. Tasks come only from campaigns with a list of employees.',
        cancel: 'Cancel',
        createTitle: 'New campaign',
        cycleValidFrom: 'Cycle valid from',
        cycleValidTo: 'Cycle valid to',
        editTitle: 'Edit campaign',
        errors: {
          conflict:
            'Check the campaign dates and whether the SAP numbers already belong to another active campaign.',
          generic: 'Could not save the campaign.',
          tasksStartDate: 'The task start date must fall inside the cycle window.',
          window: 'The "valid to" date must be later than "valid from".',
        },
        name: 'Campaign name',
        namePlaceholder: 'Optional, e.g. Cycle 2026 H1',
        sapImport: {
          clearConfirmAction: 'Clear',
          clearConfirmBody:
            'This removes {{sapCount}} numbers from the list. The action cannot be undone.',
          clearConfirmTitle: 'Clear the whole list?',
          clearList: 'Clear list',
          dropzoneBottom: 'Supported format: XLSX',
          dropzoneTop: 'Drag an XLSX file here, or click to choose one',
          errorTooMany:
            'The file holds more than 10,000 SAP numbers. Split it into smaller files and import again.',
          errorUnreadable: 'Could not read the file. Make sure it is a valid XLSX file.',
          fileHint:
            'One number per row, in the first column. Numbers must match HR data exactly. If they start with a zero, format the Excel column as text.',
          modeAppend: 'Append to list',
          modeBody:
            'The list already holds {{existingCount}} numbers and the file holds {{incomingCount}}. Append them to the current list, or replace it?',
          modeCancel: 'Cancel',
          modeReplace: 'Replace list',
          modeTitle: 'SAP numbers loaded from file',
          rejectedRow: 'row {{row}}: {{value}}',
          rejectedTitle: 'Rejected entries ({{rejectedCount}})',
          showAll: '+{{hiddenCount}} — show all',
          showLess: 'Collapse list',
          summaryDuplicates: 'Duplicates skipped: {{duplicateCount}}.',
          summarySuccess: 'Loaded {{addedCount}} numbers from file {{fileName}}.',
        },
        save: 'Save',
        targetSaps: 'Covered employee SAP numbers',
        targetSapsAdd: 'Add',
        targetSapsEmpty: 'Empty list — the campaign covers nobody and creates no tasks.',
        targetSapsHint:
          'Employees on this list are expected to build a plan in this campaign. Their P1 supervisor gets the direction-setting task, which hands over to the employee after 7 days.',
        targetSapsPlaceholder: 'e.g. 10023',
        tasksStartDate: 'Task start date',
      },
      impact: {
        activation:
          'Activating this campaign creates direction-setting tasks for the P1 supervisors of the covered employees and sends notifications. A catch-all campaign creates no tasks at all. Other active campaigns are left untouched. Continue?',
        activeEdit:
          'Saving changes to an active campaign cancels the open pre-plan tasks and recreates them from the new list of employees. The 7-day supervisor deadlines restart and notifications are sent again. Continue?',
        cancel: 'Cancel',
        confirm: 'Continue',
        deactivation:
          'Deactivating this campaign cancels the open pre-plan tasks of the employees it covers and takes away their ability to create a plan, unless a catch-all campaign picks them up. Existing plans and their tasks stay unchanged. Continue?',
        title: 'Confirm the consequences',
      },
      inactiveChip: 'Inactive',
      members: {
        back: 'Back to campaigns',
        detail: {
          back: 'Back to the list',
          cycleCampaign: 'Campaign',
          cycleDirection: 'Direction',
          cycleState: 'State',
          cycleWindow: 'Window',
          noAccount: 'No account',
          noPlans: 'This employee has no development plan yet.',
          noPlansTitle: 'No plans',
          noTaskReason: 'No-task reason',
          noTasks: 'No tasks tied to this employee’s plans.',
          noTasksTitle: 'No tasks',
          p1: 'P1 supervisor',
          pageDescription: 'Full view of one employee’s plans and tasks.',
          pageTitle: 'Employee detail',
          plansTitle: 'Development plans',
          taskDeadline: 'Deadline',
          taskDescription: 'Description',
          taskStatus: 'Status',
          tasksTitle: 'Plan tasks',
          taskTarget: 'Target',
          taskTrigger: 'Type',
          thisCampaign: 'This campaign',
        },
        emptyDescription: 'No employee matches the selected filters.',
        emptyTitle: 'No employees',
        error: 'Could not load the covered employees.',
        errorTitle: 'Error',
        filters: {
          anyPlanStatus: 'Any plan status',
          planStatusLabel: 'Plan status',
          searchPlaceholder: 'Search by name or SAP',
          withoutAccount: 'No user account',
          withoutTask: 'No task',
        },
        no: 'No',
        pageDescription:
          'Employees covered by the campaign, with plan status, task and the reason a task is missing.',
        pageTitle: 'Covered employees',
        planStatus: {
          ARCHIVED: 'Historical',
          CANCELLED: 'Cancelled',
          COMPLETED: 'Completed',
          DRAFT: 'Draft',
          NONE: 'No plan',
          READY_FOR_REALIZATION: 'Ready',
          SUPERVISOR_APPROVED: 'Approved',
          SUPERVISOR_REJECTED: 'Rejected',
        },
        reason: {
          BEFORE_TASKS_START: 'Before the campaign task start',
          CATCH_ALL: 'Catch-all campaign — creates no tasks',
          NO_USER_ACCOUNT: 'No user account',
          PENDING_SCAN: 'Waiting for the next scan',
          PLAN_EXISTS: 'Plan already exists',
        },
        source: {
          APPLY_TO_ALL: 'Catch-all campaign',
          TARGETED: 'From the list',
        },
        summary: {
          covered: 'Covered',
          withOpenTask: 'With task',
          withPlan: 'With plan',
          withUserAccount: 'With account',
        },
        table: {
          account: 'Account',
          name: 'Employee',
          p1: 'P1 supervisor',
          plan: 'Plan status',
          source: 'Source',
          task: 'Task / reason',
        },
        taskType: {
          PLAN_INITIATION: 'Initiation (P1)',
          PLAN_REQUIRED: 'Create plan',
        },
        yes: 'Yes',
      },
      noActiveCampaign:
        'No active campaign — nobody is covered, so plan creation is disabled and no tasks are generated.',
      sweep: {
        button: 'Run task creation now',
        description:
          'Runs on demand exactly what the scheduler does daily at 06:15: it creates direction-setting tasks for the supervisors of covered employees, and with no campaign it sweeps away lingering tasks.',
        result: 'Done — created tasks: {{created}}, cancelled lingering: {{cancelled}}.',
        testBadge: 'test tool',
        title: 'Task scheduler',
      },
      table: {
        actions: 'Actions',
        cancelAction: 'End campaign',
        covered: 'Covered',
        coveredAll: 'everyone',
        coveredEmpty: 'nobody',
        createButton: 'New campaign',
        deleteAction: 'Delete',
        editAction: 'Edit',
        empty: 'No development-cycle campaign has been configured yet.',
        emptyTitle: 'No campaigns',
        members: 'Members',
        membersAction: 'Show covered employees',
        name: 'Name',
        status: 'Status',
        tasksStartDate: 'Task start',
        title: 'All campaigns',
        window: 'Cycle window',
      },
    },
    employees: {
      description: 'Find employees and manage their active status in the organization.',
    },
    permissions: {
      description: 'Manage roles, permissions and user access across the system.',
    },
  },
  sidebar: {
    backToStart: 'Back to start',
    collapseAriaLabelCollapsed: 'Expand admin menu',
    collapseAriaLabelExpanded: 'Collapse admin menu',
    subtitle: 'Administration sections',
  },
  successionPermissions: {
    comingSoon: 'Coming Soon',
    description: 'Succession permissions management will be available here.',
    errors: {
      loadingData: 'Error loading data:',
      loadingUnits: 'Error loading units:',
    },
    loading: {
      data: 'Loading data...',
      units: 'Loading units...',
    },
    messages: {
      hrbpHqInfo: 'Only users with the HRBP HQ role are visible here.',
      noDataForSelectedUnits: 'No data to display for selected units.',
      saving: 'Saving...',
      selectUnits: 'Select organizational units to display HRBP permissions.',
    },
    table: {
      headers: {
        employeeCount: 'Employee Count',
        unitPosition: 'Unit / Position',
      },
    },
    unitSelection: {
      allButton: 'All',
      clearAllButton: 'Clear all',
      label: 'Select units',
      moreChipLabel: 'more',
      placeholder: 'Select organizational units',
      remainingUnitsTooltip: 'Remaining units',
    },
  },
  surveyDetail: {
    backButton: 'Back',
    backToCertification: 'Back to Certification',
    backToSurveys: 'Back to Surveys',
    createdAt: 'Created',
    createdBy: 'Author',
    deadline: 'Deadline',
    editButton: 'Edit',
    label: 'Survey',
    overview: {
      areas: 'Areas',
      categories: 'Categories',
      categoryLink: 'Links',
      closedQuestions: 'Closed',
      negative: 'Negative',
      noCategoriesFound: 'No categories found',
      openQuestions: 'Open',
      positive: 'Positive',
      procedureDescription: 'Procedure description',
      procedureName: 'Procedure',
      questions: 'Questions',
      scale: 'Rating Scale',
      searchCategories: 'Search categories...',
      selectCategoryPrompt: 'Select a category to see details',
      threshold: 'threshold',
      total: 'Total',
    },
    participants: {
      actions: 'Actions',
      answers: {
        allAreas: 'All Areas',
        allCategories: 'All Categories',
        answer: 'Answer',
        answerDuration: 'Duration: {{duration}}',
        areaFilter: 'Area',
        categoryFilter: 'Category',
        error: 'Error loading answers',
        loading: 'Loading answers...',
        noData: 'No answers found',
        questionNumber: 'Question {{number}}',
        report: {
          downloadButton: 'Download Excel report',
          downloading: 'Downloading...',
          error: 'Error downloading report',
          reportType: {
            EMPLOYEE_SURVEY_ANSWERS: 'Employee survey answers',
          },
          subtitle: 'Download a full Excel report with answers and categories below threshold.',
          title: 'Answers report',
        },
        rowsPerPage: 'Rows per page',
        searchPlaceholder: 'Search in questions or answers...',
        summary: {
          allCategoriesMet: 'There are no areas requiring improvement.',
          categoriesCount: 'Below you will find areas that need improvement',
          competencyWorkRequired: 'Competency work required',
          goToResources: 'Go to resources',
          greatJob: 'Great job!',
          howToImprove: 'What to do to increase your knowledge?',
          loading: 'Loading summary...',
          procedureDescription: 'Procedure description',
          procedureName: 'Procedure',
          questionNumber: 'Question {{number}}:',
          supportMaterials: 'Support materials:',
          viewAnswers: 'View answers',
        },
        tabAnswers: 'Participant Answers',
        tabReport: 'Answers Report',
        tabSummary: 'Employee Survey Summary',
        title: 'Participant Answers',
        totalAnswers: 'Total answers: {{count}}',
      },
      assignedAt: 'Assigned',
      completedAt: 'Completed',
      dates: 'Dates',
      details: 'Details',
      email: 'Email',
      hasSurveyAssigned: 'Survey Assigned',
      name: 'Name',
      notificationSent: 'Notification Sent',
      position: 'Position',
      search: 'Search',
      startedAt: 'Started',
      status: {
        all: 'All',
        null: 'N/A',
        [SurveyAssignmentStatusDto.Cancelled]: 'Cancelled',
        [SurveyAssignmentStatusDto.Completed]: 'Completed',
        [SurveyAssignmentStatusDto.InProgress]: 'In Progress',
        [SurveyAssignmentStatusDto.Pending]: 'Pending',
      },
      statusLabel: 'Status',
      table: {
        actions: 'Actions',
        error: 'Error loading participants',
        loading: 'Loading participants...',
        noData: 'No participants',
        rowsPerPage: 'Rows per page',
      },
      viewAnswers: 'View Answers',
    },
    questions: {
      all: 'All',
      area: 'Area',
      assignedTo: 'Assigned to',
      category: 'Category',
      categoryDetails: 'Category details',
      categoryLink: 'Open link',
      employee: 'Employee',
      filters: 'Filter',
      group: 'Group',
      position: 'Position',
      procedureDescription: 'Procedure description',
      procedureName: 'Procedure',
      total: 'Total',
      type_CLOSED: 'Closed',
      type_OPEN: 'Open',
    },
    reports: {
      download: 'Download',
      downloading: 'Downloading...',
      error: 'Error downloading report',
      reportType: {
        EMPLOYEE_SURVEY_ANSWERS: 'Employee survey answers',
      },
      subtitle: 'Download reports for all survey participants.',
    },
    status: 'Status',
    statusAction: {
      cancel: 'Cancel Survey',
      complete: 'Complete',
      start: 'Start',
    },
    statusUpdateError: 'Failed to update status',
    statusUpdateSuccess: 'Status updated',
    tabs: {
      overview: 'Overview',
      participants: 'Participants',
      questions: 'Questions',
      reports: 'Reports',
    },
  },
  surveys: {
    addButton: 'Add Survey',
    dialog: {
      cancel: 'Cancel',
      deadline: 'Deadline',
      deadlineHelp: 'Optional survey deadline date',
      dragDropText: 'or drag and drop here',
      file: 'Excel File',
      fileHelp: 'File should contain sheets: Questions, Scales, Categories',
      name: 'Survey Name',
      save: 'Save',
      saving: 'Uploading...',
      title: 'Add New Survey',
      uploadSuccess: 'Survey uploaded successfully',
    },
    editDialog: {
      cancel: 'Cancel',
      deadline: 'Deadline',
      deadlineHelp: 'Optional survey deadline date',
      name: 'Survey Name',
      nameRequired: 'Survey name is required',
      save: 'Save',
      saving: 'Saving...',
      status: 'Status',
      title: 'Edit Survey',
      updateError: 'Error updating survey',
      updateSuccess: 'Survey updated successfully',
    },
    filters: {
      search: 'Search',
    },
    status: {
      ACTIVE: 'Active',
      CANCELLED: 'Cancelled',
      COMPLETED: 'Completed',
      DRAFT: 'Draft',
    },
    statusUpdateError: 'Error updating status',
    statusUpdateSuccess: 'Survey status updated successfully',
    table: {
      actions: 'Actions',
      author: 'Author',
      createdAt: 'Created',
      deadline: 'Deadline',
      details: 'Details',
      edit: 'Edit',
      error: 'Error loading surveys',
      loading: 'Loading surveys...',
      name: 'Name',
      noData: 'No surveys available',
      participants: 'Participants',
      report: 'Report',
      rowsPerPage: 'Rows per page',
      status: 'Status',
    },
    title: 'Manage Surveys',
  },
  tabs: {
    accountsManagement: 'Accounts',
    certificationSubTabs: {
      certification: 'Certifications',
      questionPools: 'Question Pools',
      surveys: 'Surveys',
    },
    changeHistory: 'Change History',
    dataManagement: 'Data',
    dataManagementUpload: 'Upload Data',
    developmentCycles: 'Development cycles',
    devPlanTester: 'Development plan tester',
    dictionaries: 'Dictionaries',
    employeesManagement: 'Employees',
    impersonation: 'Switch user',
    news: 'News',
    permissions: 'Roles & Permissions',
    permissionSubTabs: {
      assignments: 'Assignments',
      employees: 'Employees',
      hrbpPermissions: 'HRBP HQ Permissions',
      permissions: 'Permissions',
      roles: 'Roles',
    },
    professionalActivityDefinitions: 'Development Activities',
    ragDocuments: 'Chat Documents',
    successionPermissions: 'Succession Permissions',
    surveys: 'Certification',
    taskCreator: 'Task creator (dev)',
  },
  taskCreator: {
    creating: 'Creating...',
    deadline: 'Deadline',
    description: 'Description',
    error: 'Could not create task.',
    resourceType: {
      [ResourceTypeDto.App]: 'Application',
      [ResourceTypeDto.DevelopmentPath]: 'Development path',
      [ResourceTypeDto.Employee]: 'Employee',
      [ResourceTypeDto.Survey]: 'Survey',
    },
    sourceResourceType: 'Source type',
    sourceResourceValue: 'Source value',
    submit: 'Create task',
    subtitle: 'Testing helper. Assignee is the current user; employee target uses SAP ID.',
    targetResourceType: 'Target type',
    targetResourceValue: 'Target value (SAP / external ID)',
    title: 'Task creator',
  },
  title: 'Admin Panel',
};
